import autoTable from "jspdf-autotable";
import { convertAmountToWords } from "./NumberWordHelper";
import AmiriRegular from "../../utils/Amri-Regular";
const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : "";

const getDocumentConfig = (docType) => {
  const configs = {
    delivery_order: {
      title: "DELIVERY ORDER",
      numberLabel: "DO NO:",
      dateLabel: "DO DATE:",
      numberField: "do_no",
      dateField: "do_date",
      codeField: "do_icode",
      locationField: "do_locn",
      showPricing: false,
      detailFields: [
        // { label: "QUOT NO:", field: "q_no" },
        { label: "LPO:", field: "lpo_no" },
        { label: "Salesman:", field: "sale_man" },
      ],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "REF", ratio: 0.1, align: "center" },
          { header: "CODE", ratio: 0.13, align: "center" },
          { header: "DESCRIPTION", ratio: 0.4, align: "left" },
          { header: "LOCN", ratio: 0.1, align: "center" },
          { header: "UNIT", ratio: 0.1, align: "center" },
          { header: "QTY", ratio: 0.12, align: "center" },
        ],

        withoutCode: [
          { header: "SN", ratio: 0.06, align: "center" },
          { header: "REF", ratio: 0.12, align: "center" },
          { header: "DESCRIPTION", ratio: 0.47, align: "left" },
          { header: "LOCN", ratio: 0.13, align: "center" },
          { header: "UNIT", ratio: 0.11, align: "center" },
          { header: "QTY", ratio: 0.11, align: "center" },
        ],
      },
      footerLeft: "RECEIVED BY",
    },
    sales_order: {
      title: "PROFORMA INVOICE",
      numberLabel: "SO NO:",
      dateLabel: "SO DATE:",
      numberField: "so_no",
      dateField: "so_date",
      codeField: "so_icode",
      locationField: "location",
      showPricing: true,
      detailFields: [
        { label: "SALESMAN:", field: "sale_man" },
        { label: "Lpo No:", field: "so_ref" },
      ],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.12, align: "center" },
          { header: "DESCRIPTION", ratio: 0.4, align: "left" },
          { header: "UNIT", ratio: 0.1, align: "center" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT COST", ratio: 0.12, align: "center" },
          { header: "AMOUNT", ratio: 0.12, align: "center" },
        ],
        withoutCode: [
          { header: "SN", ratio: 0.06, align: "center" },
          { header: "DESCRIPTION", ratio: 0.45, align: "left" },
          { header: "UNIT", ratio: 0.1, align: "center" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT COST", ratio: 0.14, align: "center" },
          { header: "AMOUNT", ratio: 0.15, align: "center" },
        ],
      },
      footerLeft: "PREPARED BY",
    },
    quotation: {
      title: "QUOTATION",
      numberLabel: "Quot No:",
      dateLabel: "DATE:",
      numberField: "so_no",
      dateField: "so_date",
      codeField: "so_icode",
      locationField: "location",
      showPricing: true,
      showVAT: true,
      detailFields: [{ label: "SALESMAN:", field: "sale_man" }],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.12, align: "center" },
          { header: "DESCRIPTION", ratio: 0.35, align: "left" },
          { header: "QTY", ratio: 0.08, align: "center" },
          { header: "UNIT PRICE", ratio: 0.1, align: "center" },
          { header: "AMOUNT", ratio: 0.1, align: "center" },
          { header: "VAT", ratio: 0.1, align: "center" },
          { header: "TOTAL AMOUNT", ratio: 0.1, align: "center" },
        ],
        withoutCode: [
          { header: "SN", ratio: 0.06, align: "center" },
          { header: "DESCRIPTION", ratio: 0.4, align: "left" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT PRICE", ratio: 0.12, align: "center" },
          { header: "AMOUNT", ratio: 0.12, align: "center" },
          { header: "VAT", ratio: 0.1, align: "center" },
          { header: "TOTAL AMOUNT", ratio: 0.1, align: "center" },
        ],
      },
      footerLeft: "PREPARED BY",
    },
    sales_return: {
      title: "TAX CREDIT NOTE",
      numberLabel: "SR NO:",
      dateLabel: "SR DATE:",
      numberField: "sr_no",
      dateField: "sr_date",
      codeField: "code",
      locationField: "locn",
      showPricing: true,
      showVAT: true,
      detailFields: [
        { label: "INV NO:", field: "sr_inv_no" },
        { label: "SALESMAN:", field: "sale_man" },
      ],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.14, align: "center" },
          { header: "DESCRIPTION", ratio: 0.34, align: "left" },
          { header: "QTY", ratio: 0.08, align: "center" },
          { header: "UNIT PRICE", ratio: 0.08, align: "right" },
          { header: "AMOUNT", ratio: 0.11, align: "right" },
          { header: "VAT (5%)", ratio: 0.08, align: "right" },
          { header: "TOTAL", ratio: 0.12, align: "right" },
        ],
        withoutCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "DESCRIPTION", ratio: 0.38, align: "left" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT PRICE", ratio: 0.12, align: "right" },
          { header: "AMOUNT", ratio: 0.12, align: "right" },
          { header: "VAT (5%)", ratio: 0.11, align: "right" },
          { header: "TOTAL", ratio: 0.12, align: "right" },
        ],
      },
      footerLeft: "RETURNED BY",
    },
    purchase_invoice: {
      title: "PURCHASE INVOICE",
      numberLabel: "INV NO:",
      dateLabel: "DATE:",
      numberField: "inv_no",
      dateField: "date",
      codeField: "code",
      locationField: "locn",
      showPricing: true,
      detailFields: [{ label: "REF:", field: "ref" }],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.12, align: "center" },
          { header: "DESCRIPTION", ratio: 0.35, align: "left" },
          { header: "UNIT", ratio: 0.1, align: "center" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT PRICE", ratio: 0.12, align: "right" },
          { header: "AMOUNT", ratio: 0.16, align: "right" },
        ],
        withCodeOtherCost: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.12, align: "center" },
          { header: "DESCRIPTION", ratio: 0.3, align: "left" },
          { header: "UNIT", ratio: 0.08, align: "center" },
          { header: "QTY", ratio: 0.08, align: "center" },
          { header: "UNIT PRICE", ratio: 0.1, align: "right" },
          { header: "OTHER COST", ratio: 0.1, align: "right" },
          { header: "AMOUNT", ratio: 0.17, align: "right" },
        ],
      },
      footerLeft: "RECEIVED BY",
    },
    purchase_order: {
      title: "Local Purchase Order",
      numberLabel: "PO NO:",
      dateLabel: "PO DATE:",
      numberField: "so_no",
      dateField: "so_date",
      codeField: "so_icode",
      showPricing: true,
      detailFields: [{ label: "ORD REF:", field: "so_ref" }],
    },
    branch_transfer_out: {
      title: "Branch Transfer Out",
      numberLabel: "BT NO:",
      dateLabel: "BT DATE:",
      numberField: "bt_no",
      dateField: "bt_date",
    },
    purchase_return: {
      title: "PURCHASE RETURN",
      numberLabel: "PR NO:",
      dateLabel: "PR DATE:",
      numberField: "pr_no",
      dateField: "pr_date",
      codeField: "code",
      locationField: "locn",
      showPricing: true,
      showVAT: true,
      detailFields: [
        { label: "PINV NO:", field: "tr_refno" },
        { label: "SUPP INV:", field: "pr_ref_no" },
        { label: "SALESMAN:", field: "sale_man" },
      ],
      columns: {
        withCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "CODE", ratio: 0.14, align: "center" },
          { header: "DESCRIPTION", ratio: 0.34, align: "left" },
          { header: "QTY", ratio: 0.08, align: "center" },
          { header: "UNIT PRICE", ratio: 0.08, align: "right" },
          { header: "AMOUNT", ratio: 0.11, align: "right" },
          { header: "VAT (5%)", ratio: 0.08, align: "right" },
          { header: "TOTAL", ratio: 0.12, align: "right" },
        ],
        withoutCode: [
          { header: "SN", ratio: 0.05, align: "center" },
          { header: "DESCRIPTION", ratio: 0.38, align: "left" },
          { header: "QTY", ratio: 0.1, align: "center" },
          { header: "UNIT PRICE", ratio: 0.12, align: "right" },
          { header: "AMOUNT", ratio: 0.12, align: "right" },
          { header: "VAT (5%)", ratio: 0.11, align: "right" },
          { header: "TOTAL", ratio: 0.12, align: "right" },
        ],
      },
      footerLeft: "RETURNED BY",
    },
  };

  return configs[docType] || configs.delivery_order;
};
const calculateAdvanceAmount = (grandTotal, firstItem) => {
  const advanceAmount = Number(firstItem.inv_qty || 0);
  const balanceAmount = grandTotal - advanceAmount;

  return {
    advanceAmount,
    balanceAmount,
  };
};

const drawHeader = (doc, pageWidth, headerImage) => {
  if (!headerImage) return 0;

  const padding = 5;
  const headerHeight = 35;
  const imgWidth = pageWidth - padding * 2;
  const imgHeight = headerHeight - padding * 2;

  try {
    doc.addImage(headerImage, "PNG", padding, padding, imgWidth, imgHeight);
  } catch (error) {
    console.error("Error adding header image:", error);
  }

  return headerHeight;
};

const drawFooter = (doc, pageWidth, pageHeight, footerImage) => {
  if (!footerImage) return 0;

  const padding = 5;
  const footerHeight = 30;
  const footerY = pageHeight - footerHeight;
  const imgWidth = pageWidth - padding * 2;
  const imgHeight = footerHeight - padding * 2;

  try {
    doc.addImage(
      footerImage,
      "PNG",
      padding,
      footerY + padding,
      imgWidth,
      imgHeight,
    );
  } catch (error) {
    console.error("Error adding footer image:", error);
  }

  return footerHeight;
};

// Generic function to generate table rows
const generateTableRows = (data, config, includeCode, VATPERCENTAGE) => {
  return data?.map((item, index) => {
    const row = [(index + 1).toString()];

    if (config.title === "DELIVERY ORDER") {
      row.push(item.batch || item.bin);
    }

    if (includeCode) {
      row.push(item[config.codeField] || item.icode || item.item_code || "");
    }

    row.push(item.idesc || item.tr_desc || "");

    if (config.locationField && !config.showVAT) {
      if (includeCode) {
        row.push(item[config.locationField] || "");
      } else if (config.title === "DELIVERY ORDER") {
        row.push(item[config.locationField] || "");
      }
    }

    // For non-quotation documents with unit field
    if (!config.showVAT) {
      row.push(item.unit || "PCS");
    }

    const qty = item.do_qty || item.tr_qty || item.so_qty || 0;
    row.push(qty.toFixed(2));

    // if (config.showPricing) {
    const unitCost =
      item.unit?.toUpperCase() === "FOC"
        ? 0
        : config.title === "TAX CREDIT NOTE"
          ? (item.unit_price ?? item.unit_cost ?? item.unit_ppric ?? item.rate ?? 0)
          : (item.unit_cost ?? item.unit_ppric ?? item.rate ?? item.unit_price ?? 0); const amount = qty * unitCost;

    row.push(unitCost.toFixed(2));
    row.push(amount.toFixed(2));

    // UPDATED: Only add VAT columns if showVAT is true AND deliv_site is "VAT Applied"
    if (config.showVAT && item.deliv_site === "VAT Applied") {
      const vatPercent = Number(VATPERCENTAGE) || 0;
      const vatRate = vatPercent / 100;
      const vatAmount = Math.round(Number(amount || 0) * vatRate * 100) / 100;
      const totalAmount = amount + vatAmount;
      row.push(vatAmount.toFixed(2));
      row.push(totalAmount.toFixed(2));
    } else if (config.showVAT) {
      // If showVAT but deliv_site is not "VAT Applied", push empty/zero values
      row.push("0.00");
      row.push(amount.toFixed(2)); // Total without VAT
    }
    // }

    return row;
  });
};

const generatePurchaseTableRows = (data, includeOtherCost = false) => {
  return data?.map((item, index) => {
    const qty = Number(item.qty || item.tr_qty2 || 0);
    const unitPrice = Number(item["Unit Cost"] || item.unit_price || 0);
    const amount = Number(item.AmountLine || item.amount || 0);

    const row = [
      (index + 1).toString(),
      item.code || "",
      item.description || item.idesc || "",
      item.unit || "PCS",
      qty.toFixed(2),
      unitPrice.toFixed(2),
    ];

    if (includeOtherCost) {
      const othCost = Number(item["Oth.Cost"] || item.othCost || 0);
      row.push(othCost.toFixed(2));
    }

    row.push(amount.toFixed(2));

    return row;
  });
};

const PurchaseOrderTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
  REPORT_SIGNATURE = null,
  statusStamp,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];
  const companyTRN =
    CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "-";


  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  // Title
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Purchase Order", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 7;

  // TRN
  const trnValue =
    firstItem.trnno ||
    firstItem.vat_no ||
    firstItem.trn ||
    firstItem.comp_trn ||
    "-";
  doc.setFontSize(11);
  doc.setFont(undefined, "bold");
  doc.text(`TRN : ${companyTRN}`, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 8;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const leftBoxWidth = contentWidth * 0.62;
  const rightBoxWidth = contentWidth * 0.38 - boxGap;
  const boxHeight = 35;

  // Page 1 of 1
  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Page 1 of 1", pageWidth - margin, yPosition - 2, {
    align: "right",
  });
  doc.setTextColor(0, 0, 0);

  // Left Box
  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, yPosition, leftBoxWidth, boxHeight);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.accdesc || "", margin + 2, yPosition + 7);
  const attnLineY = yPosition + boxHeight - 10;
  doc.line(margin, attnLineY, margin + leftBoxWidth, attnLineY);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(`Attn    ${firstItem.consignee || ""}`, margin + 2, attnLineY + 6);

  // Right Box
  const rightX = margin + leftBoxWidth + boxGap;
  doc.rect(rightX, yPosition, rightBoxWidth, boxHeight);
  const labelX = rightX + 2;
  const valueX = rightX + 22;
  let detailY = yPosition + 10;
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("PO NO", labelX, detailY);
  doc.text(firstItem.po_no?.toString() || "", valueX, detailY);
  detailY += 8;
  doc.text("PO DATE", labelX, detailY);
  const poDate = firstItem.po_date
    ? new Date(firstItem.po_date)
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-")
    : "";
  doc.text(poDate, valueX, detailY);

  yPosition += boxHeight + 4;

  // ===== FIXED HEIGHTS (used only for margin.bottom calculation) =====
  const footerImgHeight = REPORT_FOOTER_IMAGE ? 20 : 0;
  const sigSectionHeight = 20;
  const termsHeight = 20;
  const totalsRowH = 6;
  const totalsRows =
    4 + (Number(firstItem.rdoff || firstItem.round_off || 0) !== 0 ? 1 : 0);
  const calcTotalsBoxHeight = totalsRows * totalsRowH + 8;

  // margin.bottom reserves space so autoTable stops before the bottom sections
  const totalReserved =
    footerImgHeight + sigSectionHeight + termsHeight + calcTotalsBoxHeight + 8;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "Slno", ratio: 0.07, align: "center" },
    { header: "Code", ratio: 0.15, align: "center" },
    { header: "Description", ratio: 0.36, align: "left" },
    { header: "Unit", ratio: 0.1, align: "center" },
    { header: "Qty", ratio: 0.08, align: "center" },
    { header: "Unit Price", ratio: 0.12, align: "right" },
    { header: "Amount", ratio: 0.12, align: "right" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  // Build data rows
  const tableBody = data.map((item, index) => {
    const qty = Number(item.po_qty2 || item.tr_qty2 || item.po_qty || 0);
    const unitPrice = Number(item.po_cost || item.po_fccost || 0);
    const lineAmount = Number(
      item.fline_tota || item.line_total || qty * unitPrice,
    );
    return [
      (index + 1).toString(),
      item.po_icode || item.icode || "",
      item.idesc || "",
      item.unit || item.po_unit || "",
      qty.toFixed(2),
      unitPrice.toFixed(2),
      lineAmount.toFixed(2),
    ];
  });

  // Pad with empty rows to visually fill space down to reserved area
  const tableStartY = yPosition;
  const targetTableEndY =
    pageHeight -
    footerImgHeight -
    sigSectionHeight -
    termsHeight -
    calcTotalsBoxHeight -
    8;
  const estimatedRowHeight = 10;
  const headerRowHeight = 10;
  const usedHeight = headerRowHeight + tableBody.length * estimatedRowHeight;
  const availableHeight = targetTableEndY - tableStartY;
  const emptyRowsCount = Math.max(
    0,
    Math.floor((availableHeight - usedHeight) / estimatedRowHeight),
  );
  for (let i = 0; i < emptyRowsCount; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: [columns.map((col) => col.header)],
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    bodyStyles: { lineWidth: 0 },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: totalReserved },
    tableWidth: usableWidth,
    didDrawCell: (hookData) => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.line(
        hookData.cell.x,
        hookData.cell.y,
        hookData.cell.x,
        hookData.cell.y + hookData.cell.height,
      );
      if (hookData.column.index === hookData.table.columns.length - 1) {
        doc.line(
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y,
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y + hookData.cell.height,
        );
      }
      if (hookData.row.index === hookData.table.body.length - 1) {
        doc.line(
          hookData.cell.x,
          hookData.cell.y + hookData.cell.height,
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y + hookData.cell.height,
        );
      }
    },
  });

  // ===== KEY FIX: use actual rendered table bottom, not pre-calculated =====
  const totalsStartY = doc.lastAutoTable.finalY; // ← touches table directly

  // ===== TOTALS BOX =====
  const grossAmount = data.reduce((sum, item) => {
    if (
      item.unit?.toUpperCase() === "FOC" ||
      item.po_unit?.toUpperCase() === "FOC"
    )
      return sum;
    return sum + Number(item.fline_tota || item.line_total || 0);
  }, 0);
  const discount = Number(firstItem.po_disc || firstItem.po_fdisc || 0);
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.po_doc === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = taxableAmount * (vatRate / 100);
  const roundOff = Number(firstItem.rdoff || firstItem.round_off || 0);
  const grandTotal = taxableAmount + vatAmount + roundOff;

  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, totalsStartY, contentWidth, calcTotalsBoxHeight);

  // Amount in words (left)
  const dividerX = pageWidth / 2 + 10;
  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  const amountWords = convertAmountToWords(grandTotal, firstItem.fc || "AED");
  const wrappedWords = doc.splitTextToSize(amountWords, dividerX - margin - 4);
  doc.text(wrappedWords, margin + 2, totalsStartY + 7);

  // Totals (right)
  const rightLabelX = dividerX + 3;
  const rightValueX = pageWidth - margin - 2;
  let rightY = totalsStartY + totalsRowH;

  doc.setFontSize(8.5);
  doc.setFont(undefined, "normal");

  doc.text("Taxable Amount", rightLabelX, rightY);
  doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  doc.text("Discount :", rightLabelX, rightY);
  if (discount !== 0)
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  doc.text("Vat Amount", rightLabelX, rightY);
  doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  if (roundOff !== 0) {
    doc.text("Round Off", rightLabelX, rightY);
    doc.text(roundOff.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += totalsRowH;
  }

  doc.setFont(undefined, "bold");
  doc.setFontSize(9);
  doc.text("Net Amount", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  // ===== TERMS / DELIVERY — chains from totals bottom =====
  const termsStartY = totalsStartY + calcTotalsBoxHeight;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Terms", margin, termsStartY + 6);
  doc.setFont(undefined, "normal");
  doc.setLineWidth(0.1);
  doc.setDrawColor(0);
  doc.line(margin + 18, termsStartY + 6, margin + 80, termsStartY + 6);
  doc.text(firstItem.payment || "", margin + 20, termsStartY + 5);

  doc.setFont(undefined, "bold");
  doc.text("Delivery", margin, termsStartY + 14);
  doc.setFont(undefined, "normal");
  doc.line(margin + 20, termsStartY + 14, margin + 80, termsStartY + 14);
  doc.text(firstItem.foot1 || "", margin + 22, termsStartY + 13);

  // ===== PREPARED BY / APPROVED BY — pinned fixed above footer =====
  const sigLineY = pageHeight - footerImgHeight - 8;
  const isApproved = data[0]?.status1 === "Y";

  const sigW = 30;
  const sigH = 15;
  const sigX = pageWidth - margin - sigW;
  const sigY = sigLineY - sigH - 6;

  // 1. Draw Signature (if exists)
  if (REPORT_SIGNATURE) {
    doc.addImage(REPORT_SIGNATURE, "PNG", sigX, sigY, sigW, sigH);
  }

  // 2. Draw Company Seal (Original Seal)
  if (REPORT_SEAL_IMAGE) {
    const sealSize = 20;
    const sealX = (pageWidth - 15) - 35;
    const sealY = sigY - sealSize - 2;
    doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
  }

  // 3. Draw Status Stamp (Draft or Approved) in the SAME PLACE
  if (statusStamp) {
    const stampW = 35;
    const stampH = 20;
    // Align with the right margin, placed right above the "Approved By" text
    const stampX = pageWidth - margin - stampW;
    const stampY = sigLineY - 28; // Just above the text line

    // Note: We use the same coordinates for both Draft and Approved now
    doc.addImage(statusStamp, "PNG", stampX, stampY, stampW, stampH);
  }

  // 4. Text Labels
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.tranship || "ACCOUNTS4", margin, sigLineY - 6);

  doc.setFont(undefined, "normal");
  doc.text("Prepared By", margin, sigLineY);
  doc.text("Approved By", pageWidth - margin, sigLineY, { align: "right" });
  // Footer on all pages
  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};
export { PurchaseOrderTemplate };
const PurchaseEnquiryTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
  REPORT_SIGNATURE = null,
  statusStamp,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  // Title
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("PURCHASE ENQUIRY", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 7;

  // TRN
  const trnValue =
    firstItem.trnno ||
    firstItem.vat_no ||
    firstItem.trn ||
    firstItem.comp_trn ||
    firstItem.CCNO ||
    "-";
  doc.setFontSize(11);
  doc.setFont(undefined, "bold");
  doc.text(`TRN : ${trnValue}`, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 8;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const leftBoxWidth = contentWidth * 0.62;
  const rightBoxWidth = contentWidth * 0.38 - boxGap;
  const boxHeight = 35;

  // Page 1 of 1
  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Page 1 of 1", pageWidth - margin, yPosition - 2, {
    align: "right",
  });
  doc.setTextColor(0, 0, 0);

  // Left Box
  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, yPosition, leftBoxWidth, boxHeight);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.accdesc || "", margin + 2, yPosition + 7);
  const attnLineY = yPosition + boxHeight - 10;
  doc.line(margin, attnLineY, margin + leftBoxWidth, attnLineY);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(`Attn    ${firstItem.consignee || ""}`, margin + 2, attnLineY + 6);

  // Right Box
  const rightX = margin + leftBoxWidth + boxGap;
  doc.rect(rightX, yPosition, rightBoxWidth, boxHeight);
  const labelX = rightX + 2;
  const valueX = rightX + 22;
  let detailY = yPosition + 10;
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("ENQ NO", labelX, detailY);
  doc.text(firstItem.po_no?.toString() || "", valueX, detailY);
  detailY += 8;
  doc.text("ENQ DATE", labelX, detailY);
  const poDate = firstItem.po_date
    ? new Date(firstItem.po_date)
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-")
    : "";
  doc.text(poDate, valueX, detailY);

  yPosition += boxHeight + 4;

  // ===== FIXED HEIGHTS (used only for margin.bottom calculation) =====
  const footerImgHeight = REPORT_FOOTER_IMAGE ? 20 : 0;
  const sigSectionHeight = 20;
  const termsHeight = 20;
  const totalsRowH = 6;
  const totalsRows =
    4 + (Number(firstItem.rdoff || firstItem.round_off || 0) !== 0 ? 1 : 0);
  const calcTotalsBoxHeight = totalsRows * totalsRowH + 8;

  // margin.bottom reserves space so autoTable stops before the bottom sections
  const totalReserved =
    footerImgHeight + sigSectionHeight + termsHeight + calcTotalsBoxHeight + 8;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "Slno", ratio: 0.07, align: "center" },
    { header: "Code", ratio: 0.15, align: "center" },
    { header: "Description", ratio: 0.36, align: "left" },
    { header: "Unit", ratio: 0.1, align: "center" },
    { header: "Qty", ratio: 0.08, align: "center" },
    { header: "Unit Price", ratio: 0.12, align: "right" },
    { header: "Amount", ratio: 0.12, align: "right" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  // Build data rows
  const tableBody = data.map((item, index) => {
    const qty = Number(item.po_qty2 || item.tr_qty2 || item.po_qty || 0);
    const unitPrice = Number(item.po_cost || item.po_fccost || 0);
    const lineAmount = Number(
      item.fline_tota || item.line_total || qty * unitPrice,
    );
    return [
      (index + 1).toString(),
      item.po_icode || item.icode || "",
      item.idesc || "",
      item.unit || item.po_unit || "",
      qty.toFixed(2),
      unitPrice.toFixed(2),
      lineAmount.toFixed(2),
    ];
  });

  // Pad with empty rows to visually fill space down to reserved area
  const tableStartY = yPosition;
  const targetTableEndY =
    pageHeight -
    footerImgHeight -
    sigSectionHeight -
    termsHeight -
    calcTotalsBoxHeight -
    8;
  const estimatedRowHeight = 10;
  const headerRowHeight = 10;
  const usedHeight = headerRowHeight + tableBody.length * estimatedRowHeight;
  const availableHeight = targetTableEndY - tableStartY;
  const emptyRowsCount = Math.max(
    0,
    Math.floor((availableHeight - usedHeight) / estimatedRowHeight),
  );
  for (let i = 0; i < emptyRowsCount; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: [columns.map((col) => col.header)],
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    bodyStyles: { lineWidth: 0 },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: totalReserved },
    tableWidth: usableWidth,
    didDrawCell: (hookData) => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.line(
        hookData.cell.x,
        hookData.cell.y,
        hookData.cell.x,
        hookData.cell.y + hookData.cell.height,
      );
      if (hookData.column.index === hookData.table.columns.length - 1) {
        doc.line(
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y,
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y + hookData.cell.height,
        );
      }
      if (hookData.row.index === hookData.table.body.length - 1) {
        doc.line(
          hookData.cell.x,
          hookData.cell.y + hookData.cell.height,
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y + hookData.cell.height,
        );
      }
    },
  });

  // ===== KEY FIX: use actual rendered table bottom, not pre-calculated =====
  const totalsStartY = doc.lastAutoTable.finalY; // ← touches table directly

  // ===== TOTALS BOX =====
  const grossAmount = data.reduce((sum, item) => {
    if (
      item.unit?.toUpperCase() === "FOC" ||
      item.po_unit?.toUpperCase() === "FOC"
    )
      return sum;
    return sum + Number(item.fline_tota || item.line_total || 0);
  }, 0);
  const discount = Number(firstItem.po_disc || firstItem.po_fdisc || 0);
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.po_doc === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = taxableAmount * (vatRate / 100);
  const roundOff = Number(firstItem.rdoff || firstItem.round_off || 0);
  const grandTotal = taxableAmount + vatAmount + roundOff;

  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, totalsStartY, contentWidth, calcTotalsBoxHeight);

  // Amount in words (left)
  const dividerX = pageWidth / 2 + 10;
  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  const amountWords = convertAmountToWords(grandTotal, firstItem.fc || "AED");
  const wrappedWords = doc.splitTextToSize(amountWords, dividerX - margin - 4);
  doc.text(wrappedWords, margin + 2, totalsStartY + 7);

  // Totals (right)
  const rightLabelX = dividerX + 3;
  const rightValueX = pageWidth - margin - 2;
  let rightY = totalsStartY + totalsRowH;

  doc.setFontSize(8.5);
  doc.setFont(undefined, "normal");

  doc.text("Taxable Amount", rightLabelX, rightY);
  doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  doc.text("Discount :", rightLabelX, rightY);
  if (discount !== 0)
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  doc.text("Vat Amount", rightLabelX, rightY);
  doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  if (roundOff !== 0) {
    doc.text("Round Off", rightLabelX, rightY);
    doc.text(roundOff.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += totalsRowH;
  }

  doc.setFont(undefined, "bold");
  doc.setFontSize(9);
  doc.text("Net Amount", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  // ===== TERMS / DELIVERY — chains from totals bottom =====
  const termsStartY = totalsStartY + calcTotalsBoxHeight;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Terms", margin, termsStartY + 6);
  doc.setFont(undefined, "normal");
  doc.setLineWidth(0.1);
  doc.setDrawColor(0);
  doc.line(margin + 18, termsStartY + 6, margin + 80, termsStartY + 6);
  doc.text(firstItem.payment || "", margin + 20, termsStartY + 5);

  doc.setFont(undefined, "bold");
  doc.text("Delivery", margin, termsStartY + 14);
  doc.setFont(undefined, "normal");
  doc.line(margin + 20, termsStartY + 14, margin + 80, termsStartY + 14);
  doc.text(firstItem.foot1 || "", margin + 22, termsStartY + 13);

  // ===== PREPARED BY / APPROVED BY — pinned fixed above footer =====
  const sigLineY = pageHeight - footerImgHeight - 8;
  const isApproved = data[0]?.status1 === "Y";

  const sigW = 30;
  const sigH = 15;
  const sigX = pageWidth - margin - sigW;
  const sigY = sigLineY - sigH - 6;

  // 1. Draw Signature (if exists)
  if (REPORT_SIGNATURE) {
    doc.addImage(REPORT_SIGNATURE, "PNG", sigX, sigY, sigW, sigH);
  }

  // 2. Draw Company Seal (Original Seal)
  if (REPORT_SEAL_IMAGE) {
    const sealSize = 20;
    const sealX = (pageWidth - 15) - 35;
    const sealY = sigY - sealSize - 2;
    doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
  }

  // 3. Draw Status Stamp (Draft or Approved) in the SAME PLACE
  if (statusStamp) {
    const stampW = 35;
    const stampH = 20;
    // Align with the right margin, placed right above the "Approved By" text
    const stampX = pageWidth - margin - stampW;
    const stampY = sigLineY - 28; // Just above the text line

    // Note: We use the same coordinates for both Draft and Approved now
    doc.addImage(statusStamp, "PNG", stampX, stampY, stampW, stampH);
  }

  // 4. Text Labels
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.tranship || "ACCOUNTS4", margin, sigLineY - 6);

  doc.setFont(undefined, "normal");
  doc.text("Prepared By", margin, sigLineY);
  doc.text("Approved By", pageWidth - margin, sigLineY, { align: "right" });
  // Footer on all pages
  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};
export { PurchaseEnquiryTemplate };

const QuotationTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
  REPORT_SIGNATURE = null,
  includeCode = false,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];
  console.log("firstItem QUOT", firstItem)

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;

  // Start drawing the content below the header image
  let yPosition = headerHeight > 0 ? headerHeight + 10 : 20;

  const margin = 15;
  const usableWidth = pageWidth - 2 * margin;

  // ==========================================
  // ==== 3-COLUMN HEADER GRID (Modern) ====
  // ==========================================
  const colWidth = usableWidth / 3;
  const fromX = margin;
  const billToX = margin + colWidth;
  const detailsX = margin + colWidth * 2;

  // Column Headers (Upper Case, Muted Styling)
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139); // Slate-500
  doc.text("FROM", fromX, yPosition);
  doc.text("BILL TO", billToX, yPosition);
  doc.text("DETAILS", detailsX, yPosition);

  yPosition += 6;

  // -- Column 1: From (Company details) --
  // Note: Adjust the fields below if your static company info needs to pull dynamically
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 41, 59); // Slate-800
  doc.text(COMPANY_NAME, fromX, yPosition);

  doc.setFont(undefined, "normal");
  doc.setFontSize(8.5);
  doc.setTextColor(71, 85, 105); // Slate-600

  const companyTRN = CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "";
  let fromY = yPosition + 4.5;
  if (companyTRN) {
    doc.text(`TRN: ${companyTRN}`, fromX, fromY);
    fromY += 4.5;
  }
  // Add additional standard fallback address fields if they exist in your scope here

  // -- Column 2: Bill To (Customer Details) --
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 41, 59);
  doc.text(firstItem.custref || firstItem.tr_desc || "", billToX, yPosition);

  doc.setFont(undefined, "normal");
  doc.setFontSize(8.5);
  doc.setTextColor(71, 85, 105);

  let billToY = yPosition + 4.5;
  const customerAddress = doc.splitTextToSize(firstItem.address2 || "-", colWidth - 5);
  doc.text(customerAddress, billToX, billToY);
  billToY += customerAddress.length * 4;

  if (firstItem.tel) {
    doc.text(`Tel: ${firstItem.tel}`, billToX, billToY);
    billToY += 4.5;
  }

  const trnLabel = VATMODE === "SAUDIPHASE1" || VATMODE === "SAUDIPHASE2" ? "Ref Code" : "Ref / TRN";
  doc.text(`${trnLabel}: ${firstItem.governor || "-"}`, billToX, billToY);

  // -- Column 3: Details (Document Meta) --
  let detailsY = yPosition;
  const detailLabelX = detailsX;
  const detailValueX = pageWidth - margin;

  const drawDetailRow = (label, value) => {
    doc.setFont(undefined, "bold");
    doc.setTextColor(71, 85, 105);
    doc.text(label, detailLabelX, detailsY);
    doc.setFont(undefined, "normal");
    doc.setTextColor(15, 23, 42);
    doc.text(value, detailValueX, detailsY, { align: "right" });
    detailsY += 5.5;
  };

  const docNo = firstItem.so_no?.toString() || firstItem.q_no || "-";
  drawDetailRow("Invoice No:", docNo); // Labels match the sample context styling

  const docDate = firstItem.so_date
    ? new Date(firstItem.so_date).toLocaleDateString("en-GB").replace(/\//g, "/")
    : "-";
  drawDetailRow("Date:", docDate);

  const currency = firstItem.fc || "AED";
  drawDetailRow("Currency:", currency);

  const config = getDocumentConfig("quotation");
  config.detailFields.forEach((field) => {
    drawDetailRow(`${field.label}:`, firstItem[field.field]?.toString() || "—");
  });

  // Keep tracking yPosition dynamically based on the tallest column
  yPosition = Math.max(fromY, billToY, detailsY) + 12;

  // ==========================================
  // ==== ITEMS TABLE (Modern Minimalist) ====
  // ==========================================
  const columns = includeCode ? config.columns.withCode : config.columns.withoutCode;

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header.toUpperCase())];
  const tableBody = generateTableRows(data, config, includeCode, VATPERCENTAGE);

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: yPosition,
    theme: "plain",
    styles: {
      fontSize: 8.5,
      cellPadding: { top: 6, right: 4, bottom: 6, left: 4 },
      overflow: "linebreak",
      textColor: [30, 41, 59],
    },
    headStyles: {
      fontStyle: "bold",
      fillColor: [248, 250, 252], // Very soft gray background for head (Modern look)
      textColor: [71, 85, 105],
    },
    columnStyles,
    margin: { left: margin, right: margin, bottom: 80 },
    tableWidth: usableWidth,
    didDrawCell: (hookData) => {
      // Draw subtle light gray bottom borders under rows instead of box grids
      if (hookData.row.section === 'body' || hookData.row.section === 'head') {
        doc.setDrawColor(241, 245, 249); // Slate-100 border line
        doc.setLineWidth(0.5);
        doc.line(
          hookData.cell.x,
          hookData.cell.y + hookData.cell.height,
          hookData.cell.x + hookData.cell.width,
          hookData.cell.y + hookData.cell.height,
        );
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 12;

  // ==========================================
  // ==== CALCULATIONS & TOTALS ====
  // ==========================================
  const grossAmount = data.reduce((sum, item) => {
    const isFOC =
      item.foc === 1 ||
      item.foc === true ||
      item.unit?.toUpperCase() === "FOC" ||
      item.freeQty > 0;
    if (isFOC) return sum;
    const qty = item.tr_qty || item.so_qty || item.qty || 0;
    const unitCost =
      item.unit_cost || item.unit_ppric || item.rate || item.unitPrice || item.so_cost || 0;
    return sum + qty * unitCost;
  }, 0);

  const discount = firstItem.discount || firstItem.disc_amt || 0;
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.deliv_site === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = taxableAmount * (vatRate / 100);
  const grandTotal = taxableAmount + vatAmount;

  // ---- Left Side: Ribbon Amount In Words & Terms ----
  const leftSideWidth = usableWidth * 0.55;

  // Highlighted Modern Amount Ribbon Box
  doc.setFillColor(248, 250, 252);
  doc.rect(margin, currentY, leftSideWidth, 10, "F");

  // Clean Dark Blue/Slate Accent bar on the left edge of the ribbon box
  doc.setFillColor(30, 41, 59);
  doc.rect(margin, currentY, 1.5, 10, "F");

  doc.setFontSize(8.5);
  doc.setFont(undefined, "bold");
  doc.setTextColor(15, 23, 42);
  const amountInWords = convertAmountToWords(grandTotal, currency).toUpperCase();
  doc.text(`${currency}: ${amountInWords}`, margin + 5, currentY + 6.5);

  // Payment Instructions text below ribbon block
  let termsY = currentY + 16;
  doc.setFontSize(8.5);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("Payment Instructions:", margin, termsY);

  doc.setFont(undefined, "normal");
  doc.setTextColor(71, 85, 105);
  termsY += 4.5;
  const paymentText = firstItem.payment_terms || firstItem.payment || "Kindly arrange payments to company terms.";
  doc.text(paymentText, margin, termsY);

  // ---- Right Side: Totals Breakdown Table Structure ----
  const rightLabelsX = margin + leftSideWidth + 15;
  const rightValuesX = pageWidth - margin;
  let totalsY = currentY + 6;

  const drawTotalRow = (label, value, isBold = false, isDiscount = false) => {
    doc.setFont(undefined, isBold ? "bold" : "normal");
    doc.setFontSize(isBold ? 10 : 9);
    doc.setTextColor(...(isBold ? [15, 23, 42] : [71, 85, 105]));
    doc.text(label, rightLabelsX, totalsY);

    if (isDiscount && value !== "0.00" && value !== 0) {
      doc.setTextColor(239, 68, 68); // Soft Red for discounts
      doc.text(`-${value}`, rightValuesX, totalsY, { align: "right" });
    } else {
      if (isBold) doc.setTextColor(15, 23, 42);
      doc.text(value.toString(), rightValuesX, totalsY, { align: "right" });
    }
    totalsY += 6;
  };

  drawTotalRow("Total [Excl. VAT]:", grossAmount.toFixed(2));
  drawTotalRow("Discount:", discount.toFixed(2), false, true);
  drawTotalRow("Taxable Amount:", taxableAmount.toFixed(2));
  drawTotalRow(`VAT Amount (${vatRate}%):`, vatAmount.toFixed(2));

  // Divider line before Net Total
  totalsY -= 2;
  doc.setDrawColor(226, 232, 240);
  doc.setLineWidth(0.5);
  doc.line(rightLabelsX, totalsY, rightValuesX, totalsY);
  totalsY += 6;

  // Final Net Balance Row
  drawTotalRow(`Total Due (${currency}):`, grandTotal.toFixed(2), true);

  // Move dynamic tracking cursor down past calculations area
  currentY = Math.max(termsY + 10, totalsY + 10);

  // ==========================================
  // ==== SIGNATURE FOOTER AREA ====
  // ==========================================
  const sigY = pageHeight - 35;
  const sigLineWidth = usableWidth * 0.35;

  // Left Signee: Receiver
  doc.setDrawColor(203, 213, 225);
  doc.setLineWidth(0.5);
  doc.line(margin, sigY, margin + sigLineWidth, sigY);

  doc.setFontSize(8.5);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("Receiver's Signature", margin, sigY + 5);

  // Right Signee: Authorized Issuer
  const rightSigStartX = pageWidth - margin - sigLineWidth;
  doc.line(rightSigStartX, sigY, pageWidth - margin, sigY);

  if (REPORT_SEAL_IMAGE) {
    const sealSize = 22;
    const sealX = pageWidth - margin - sealSize - 5;
    const sealY = sigY - sealSize - 5;
    doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
  }

  doc.text(`For ${COMPANY_NAME.toUpperCase()}`, pageWidth - margin, sigY + 5, { align: "right" });

  // ==== Render base background page footer elements on every page loop ====
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
  }
};
export { QuotationTemplate };

const GoodsInTransitTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Goods In Transit", pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += 10;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const leftBoxWidth = contentWidth * 0.62;
  const rightBoxWidth = contentWidth * 0.38 - boxGap;
  const boxHeight = 28;

  doc.setDrawColor(180);
  doc.setLineWidth(0.3);
  doc.rect(margin, yPosition, leftBoxWidth, boxHeight);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.accdesc || "", margin + 2, yPosition + 6);

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(
    firstItem.comments || firstItem.to || "",
    margin + 2,
    yPosition + 12,
  );

  doc.setFont(undefined, "bold");
  doc.text(
    `${VATMODE === "SAUDIPHASE1" || VATMODE === "SAUDIPHASE2"
      ? "Client Vat Reg No"
      : "CLIENT TRN"
    }: ${firstItem.governor || "-"}`,
    margin + 2,
    yPosition + 21,
  );

  const rightX = margin + leftBoxWidth + boxGap;
  doc.rect(rightX, yPosition, rightBoxWidth, boxHeight);

  const labelX = rightX + 2;
  const colonX = rightX + 22;
  const valueX = colonX + 3;
  let detailY = yPosition + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");

  doc.text("GIT NO", labelX, detailY);
  doc.text(":", colonX, detailY);
  doc.text(firstItem.po_no?.toString() || "", valueX, detailY);

  detailY += 6;
  doc.text("DATE", labelX, detailY);
  doc.text(":", colonX, detailY);
  const docDate = firstItem.po_date
    ? new Date(firstItem.po_date).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailY);

  detailY += 6;
  doc.text("ARRIVAL DATE", labelX, detailY);
  doc.text(":", colonX, detailY);
  const arrDate = firstItem.due_date
    ? new Date(firstItem.due_date).toLocaleDateString("en-GB")
    : "";
  doc.text(arrDate, valueX, detailY);

  detailY += 6;
  doc.text("ORD REF", labelX, detailY);
  doc.text(":", colonX, detailY);
  doc.text(firstItem.po_ref || "", valueX, detailY);

  yPosition += boxHeight + 8;

  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.text(`Attention: ${firstItem.consignee || "-"}`, margin, yPosition);
  doc.text(
    `Ship. Ref: ${firstItem.head1 || "-"}`,
    pageWidth / 2 - 20,
    yPosition,
  );
  doc.text(
    `Terms: ${firstItem.payment || "-"}`,
    pageWidth - margin - 50,
    yPosition,
  );
  yPosition += 5;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "Slno", ratio: 0.06, align: "center" },
    { header: "Code", ratio: 0.14, align: "center" },
    { header: "Description", ratio: 0.4, align: "left" },
    { header: "Loc", ratio: 0.08, align: "center" },
    { header: "Qty", ratio: 0.08, align: "center" },
    { header: "Unit", ratio: 0.08, align: "center" },
    { header: "Unit Cost", ratio: 0.08, align: "right" },
    { header: "Amount", ratio: 0.08, align: "right" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = data.map((item, index) => {
    const qty = Number(item.po_qty2 || item.tr_qty2 || item.po_qty || 0);
    const unitPrice = Number(item.po_cost || item.po_fccost || 0);
    const lineAmount = Number(
      item.fline_tota || item.line_total || qty * unitPrice,
    );

    return [
      (index + 1).toString(),
      item.po_icode || item.icode || "",
      item.idesc || "",
      item.po_locn || "",
      qty.toFixed(2),
      item.unit?.trim() || "PCS",
      unitPrice.toFixed(2),
      lineAmount.toFixed(2),
    ];
  });

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: yPosition,
    theme: "plain",
    styles: {
      fontSize: 7,
      cellPadding: 1.5,
      overflow: "linebreak",
      textColor: [120, 120, 120],
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [241, 245, 249],
      textColor: [120, 120, 120],
      lineWidth: 0.1,
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: 40 },
    tableWidth: usableWidth,
  });

  let currentY = doc.lastAutoTable.finalY + 5;

  const grossAmount = data.reduce((sum, item) => {
    if (
      item.unit?.toUpperCase() === "FOC" ||
      item.po_unit?.toUpperCase() === "FOC"
    )
      return sum;
    const lineAmount = Number(item.fline_tota || item.line_total || 0);
    return sum + lineAmount;
  }, 0);

  const discount = Number(firstItem.po_disc || firstItem.po_fdisc || 0);
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.po_doc === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = taxableAmount * (vatRate / 100);
  const roundOff = Number(firstItem.rdoff || firstItem.round_off || 0);
  const grandTotal = taxableAmount + vatAmount + roundOff;

  const boxStartY = currentY;
  const totalBoxHeight = 35;

  doc.setDrawColor(180);
  doc.setLineWidth(0.1);
  doc.rect(margin, boxStartY, contentWidth, totalBoxHeight);

  const leftX = margin + 2;
  let leftY = boxStartY + 5;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text(
    `${convertAmountToWords(grandTotal, firstItem.fc || "AED")}`,
    leftX,
    leftY,
  );
  leftY += 8;

  doc.setFont(undefined, "normal");
  doc.setFontSize(7);
  doc.text(`C&F Agent: ${firstItem.notify || "-"}`, leftX, leftY);
  leftY += 4;
  doc.text(`Delivery: ${firstItem.foot1 || "-"}`, leftX, leftY);
  leftY += 4;
  doc.text(`Job Code: ${firstItem.job_code || "-"}`, leftX, leftY);

  const rightLabelX = pageWidth / 2 + 30;
  const rightValueX = pageWidth - margin - 2;
  let rightY = boxStartY + 5;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");

  doc.text("Gross Total", rightLabelX, rightY);
  doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  doc.text("Net Total", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  currentY = boxStartY + totalBoxHeight + 15;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text("PREPARED BY", 20, currentY);
  doc.text("CHECKED BY", pageWidth / 2, currentY, { align: "center" });
  doc.text("APPROVED BY", pageWidth - 20, currentY, { align: "right" });

  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};

const BranchTransferOutTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
) => {
  // 1. Setup Header & Basic Constants
  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 12;
  const margin = 15;

  const contentWidth = pageWidth - (2 * margin);
  const firstItem = data[0] || {};
  const centerX = pageWidth / 2;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(30, 41, 59);
  doc.text("BRANCH TRANSFER OUT", centerX, yPosition, { align: "center" });
  yPosition += 5;

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  yPosition += 8;

  // 3. Two-Column Metadata Block (Standard Invoice Information Layout)
  const col1_X = margin;
  const col2_X = pageWidth * 0.58;
  const valueOffset = 30;

  doc.setFontSize(9);

  // --- Left Side: Transfer Destination Routing ---
  doc.setFont("helvetica", "bold");
  doc.setTextColor(30, 41, 59);
  doc.text("TRANSFER TO", col1_X, yPosition);

  doc.setFont("helvetica", "bold");
  doc.setTextColor(15, 23, 42);
  doc.text(firstItem.DrAccDesc || "-", col1_X, yPosition + 5);

  doc.setFont("helvetica", "normal");
  doc.setTextColor(71, 85, 105);
  doc.text(`Account Code :  ${firstItem.cust_acc || "-"}`, col1_X, yPosition + 10);
  if (firstItem.deptno) {
    doc.text(`Department   :  ${firstItem.deptno.trim()}`, col1_X, yPosition + 14);
  }

  // --- Right Side: Structured Document References ---
  let rightY = yPosition;
  const voucherDetails = [
    { label: "Voucher No", value: firstItem.inv_no || "-" },
    {
      label: "Transfer Date",
      value: firstItem.inv_date ? new Date(firstItem.inv_date).toLocaleDateString("en-GB") : "-"
    },
    { label: "Prepared By", value: firstItem.user_id || "-" },
  ];

  voucherDetails.forEach((row) => {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(30, 41, 59);
    doc.text(`${row.label}:`, col2_X, rightY);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(String(row.value), col2_X + valueOffset, rightY);
    rightY += 4.5;
  });

  // Smooth layout buffering prior to rendering line items
  yPosition = Math.max(yPosition + 18, rightY) + 6;

  // 4. Line Items Table Mapping (Purely Inventory Focus)
  const tableData = data.map((item, index) => [
    index + 1,
    item.code || "",
    item.idesc || "",
    item.unit || "",
    Number(item.tr_qty || 0).toFixed(2),
  ]);

  autoTable(doc, {
    startY: yPosition,
    head: [["S.NO", "ITEM CODE", "ITEM DESCRIPTION", "UNIT", "QTY"]],
    body: tableData,
    theme: "plain",
    headStyles: {
      fillColor: false,
      textColor: [30, 41, 59],
      fontStyle: "bold",
      fontSize: 8.5,
      lineWidth: { top: 0.5, bottom: 0.5, left: 0, right: 0 },
      borderColor: [30, 41, 59],
    },
    styles: {
      fontSize: 8,
      cellPadding: { left: 4, right: 4, top: 4, bottom: 4 },
      font: "helvetica",
      textColor: [30, 41, 59],
    },
    // Aligned headers perfectly over the matching data positions below them
    columnStyles: {
      0: { cellWidth: 15, halign: "center" },   // Serial
      1: { cellWidth: 42, halign: "left" },     // Item Code (Left aligned)
      2: { cellWidth: "auto", halign: "left" },   // Description (Left aligned)
      3: { cellWidth: 20, halign: "center" },   // Unit
      4: { cellWidth: 22, halign: "right" },    // Quantity (Right aligned)
    },
    // Inject subtle row dividers to keep readability without relying on ugly zebra stripes
    didDrawCell: (data) => {
      if (data.section === "body") {
        doc.setDrawColor(30, 41, 59);
        doc.setLineWidth(0.3);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height
        );
      }
    },
    margin: { left: margin, right: margin, bottom: 45 },
    tableWidth: contentWidth,
  });

  // 5. Grand Total Summary Line
  let currentY = doc.lastAutoTable.finalY + 8;
  const totalQty = data.reduce((sum, item) => sum + Number(item.tr_qty || 0), 0);

  doc.setFontSize(8.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(30, 41, 59);

  doc.text("Total Quantities Transferred:", pageWidth - margin - 35, currentY, { align: "right" });
  doc.text(totalQty.toFixed(2), pageWidth - margin, currentY, { align: "right" });

  // 6. Signatures Section Base Alignment
  currentY = Math.max(currentY + 25, pageHeight - 35);

  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(30, 41, 59);

  // Modern clean line anchor separating line elements from authorized signature fields
  doc.setDrawColor(226, 232, 240);
  doc.setLineWidth(0.5);
  doc.line(margin, currentY - 5, pageWidth - margin, currentY - 5);

  doc.text("PREPARED BY", margin + 2, currentY);
  doc.text("CHECKED BY", pageWidth / 2, currentY, { align: "center" });
  doc.text("RECEIVED BY", pageWidth - margin - 2, currentY, { align: "right" });

  // 7. Footer Page Injection Loop
  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};

// ==================== LOCATION TRANSFER TEMPLATE ====================
const LocationTransferTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;

  const firstItem = data[0];

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;

  let yPosition = headerHeight + 10;

  // =====================================
  // TITLE
  // =====================================
  doc.setFontSize(18);
  doc.setFont(undefined, "bold");

  doc.text(
    "LOCATION TRANSFER",
    pageWidth / 2,
    yPosition,
    { align: "center" }
  );

  yPosition += 12;

  // =====================================
  // DOCUMENT DETAILS
  // =====================================
  const margin = 15;

  doc.setDrawColor(0);
  doc.setLineWidth(0.3);

  const boxHeight = 25;
  const boxWidth = pageWidth - margin * 2;

  doc.rect(
    margin,
    yPosition,
    boxWidth,
    boxHeight
  );

  const leftX = margin + 3;
  const rightX = pageWidth / 2 + 5;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");

  doc.text(
    `Transfer No : ${firstItem.LOCTR_NO ||
    firstItem.inv_no ||
    ""
    }`,
    leftX,
    yPosition + 7
  );

  doc.text(
    `Date : ${firstItem.date
      ? new Date(
        firstItem.date
      ).toLocaleDateString("en-GB")
      : ""
    }`,
    rightX,
    yPosition + 7
  );

  doc.text(
    `From : ${firstItem.FROM || ""}`,
    leftX,
    yPosition + 15
  );

  doc.text(
    `To : ${firstItem.TO || ""}`,
    rightX,
    yPosition + 15
  );

  doc.text(
    `Entered By : ${firstItem.enteredby || ""
    }`,
    leftX,
    yPosition + 23
  );

  doc.text(
    `Description : ${firstItem.remarks ||
    firstItem.tr_desc ||
    ""
    }`,
    rightX,
    yPosition + 23
  );

  yPosition += boxHeight + 8;

  // =====================================
  // ITEMS TABLE
  // =====================================
  const leftMargin = 15;
  const rightMargin = 15;

  const usableWidth =
    pageWidth -
    leftMargin -
    rightMargin;

  const columns = [
    {
      header: "SN",
      ratio: 0.08,
      align: "center",
    },
    {
      header: "ITEM CODE",
      ratio: 0.18,
      align: "center",
    },
    {
      header: "DESCRIPTION",
      ratio: 0.50,
      align: "left",
    },
    {
      header: "UNIT",
      ratio: 0.10,
      align: "center",
    },
    {
      header: "QTY",
      ratio: 0.14,
      align: "right",
    },
  ];

  const columnStyles = {};

  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [
    columns.map((col) => col.header),
  ];

  const tableBody = data.map(
    (item, index) => [
      (index + 1).toString(),
      (item.code || "").trim(),
      (item.idesc || "").trim(),
      (item.unit || "").trim(),
      Number(
        item.tr_qty ||
        item.tr_qty2 ||
        0
      ).toFixed(2),
    ]
  );

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: yPosition,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: "linebreak",
      textColor: [0, 0, 0],
    },

    headStyles: {
      fillColor: [3, 135, 189],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles,

    margin: {
      left: leftMargin,
      right: rightMargin,
    },

    tableWidth: usableWidth,
  });

  // =====================================
  // FOOTER IMAGE
  // =====================================
  if (REPORT_FOOTER_IMAGE) {
    const pageCount =
      doc.internal.getNumberOfPages();

    for (
      let i = 1;
      i <= pageCount;
      i++
    ) {
      doc.setPage(i);

      drawFooter(
        doc,
        pageWidth,
        pageHeight,
        REPORT_FOOTER_IMAGE
      );
    }
  }
};

// ==================== PURCHASE INVOICE TEMPLATES ====================
const PurchaseInvoiceStandard = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;
  const companyTRN =
    CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "-";

  // Title
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(firstItem?.local === 'L' ? "LOCAL PURCHASE INVOICE" : "IMPORT PURCHASE INVOICE", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 7;
  // TRN
  // const trnValue = firstItem.trn || firstItem.trnno || firstItem.vat_no || "-";
  doc.setFontSize(11);
  doc.setFont(undefined, "bold");
  doc.text(`TRN : ${companyTRN}`, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 8;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const leftBoxWidth = contentWidth * 0.62;
  const rightBoxWidth = contentWidth * 0.38 - boxGap;
  const boxHeight = 35;

  // Page tracking info
  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Page 1 of 1", pageWidth - margin, yPosition - 2, { align: "right" });
  doc.setTextColor(0, 0, 0);

  // Left Supplier Box
  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, yPosition, leftBoxWidth, boxHeight);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.accdesc || "", margin + 2, yPosition + 7);

  const attnLineY = yPosition + boxHeight - 10;
  doc.line(margin, attnLineY, margin + leftBoxWidth, attnLineY);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(`Account: ${firstItem.account?.trim() || "-"}`, margin + 2, attnLineY + 6);

  // Right Details Box
  const rightX = margin + leftBoxWidth + boxGap;
  doc.rect(rightX, yPosition, rightBoxWidth, boxHeight);
  const labelX = rightX + 2;
  const valueX = rightX + 22;
  let detailY = yPosition + 8;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("INV NO", labelX, detailY);
  doc.text(firstItem.inv_no?.toString() || "", valueX, detailY);
  detailY += 6;
  doc.text("DATE", labelX, detailY);
  const docDate = firstItem.date
    ? new Date(firstItem.date).toLocaleDateString("en-GB").replace(/\//g, "-")
    : "";
  doc.text(docDate, valueX, detailY);

  if (firstItem.local !== 'L') {
    detailY += 6;
    doc.text("DOC REF", labelX, detailY);
    doc.text(firstItem.docref?.toString() || "-", valueX, detailY);
  }

  detailY += 6;
  doc.text("Supp. Inv", labelX, detailY);
  doc.text(firstItem.inv?.toString() || "-", valueX, detailY);

  detailY += 6;
  doc.text("PO NO", labelX, detailY);
  doc.text(firstItem.ref?.toString() || "-", valueX, detailY);

  yPosition += boxHeight + 4;
  // ===== FIXED HEIGHTS FOR SPACE RESERVATION =====
  const footerImgHeight = REPORT_FOOTER_IMAGE ? 20 : 0;
  const sigSectionHeight = 20;
  const remarksHeight = 15;
  const totalsRowH = 6;
  const discount = Number(firstItem.discount || firstItem.disc_amt || 0);
  const totalsRows = 4 + (discount !== 0 ? 1 : 0) + (Number(firstItem.rdoff || 0) !== 0 ? 1 : 0);
  const calcTotalsBoxHeight = totalsRows * totalsRowH + 8;

  const totalReserved = footerImgHeight + sigSectionHeight + remarksHeight + calcTotalsBoxHeight + 8;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "Slno", ratio: 0.07, align: "center" },
    { header: "Code", ratio: 0.15, align: "center" },
    { header: "Description", ratio: 0.36, align: "left" },
    { header: "Unit", ratio: 0.1, align: "center" },
    { header: "Qty", ratio: 0.08, align: "center" },
    { header: "Unit Price", ratio: 0.12, align: "right" },
    { header: "Amount", ratio: 0.12, align: "right" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  // Dynamic Item Row Parsing & Math Corrections
  const tableBody = data.map((item, index) => {
    const qty = Number(item.tr_qty2 || item.qty || 0);
    const unitPrice = Number(item.unit_price || item.funit_pric || 0);
    // Explicit multiplication overrides misleading fline_tota parent allocations
    const lineAmount = qty * unitPrice;

    return [
      (index + 1).toString(),
      item.code || item.po_icode || "",
      item.idesc || "",
      item.unit || "",
      qty.toFixed(2),
      unitPrice.toFixed(2),
      lineAmount.toFixed(2),
    ];
  });

  // Dynamic Blank Row Padding Execution
  const tableStartY = yPosition;
  const targetTableEndY = pageHeight - totalReserved;
  const estimatedRowHeight = 10;
  const headerRowHeight = 10;
  const usedHeight = headerRowHeight + tableBody.length * estimatedRowHeight;
  const availableHeight = targetTableEndY - tableStartY;
  const emptyRowsCount = Math.max(0, Math.floor((availableHeight - usedHeight) / estimatedRowHeight));

  for (let i = 0; i < emptyRowsCount; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: [columns.map((col) => col.header)],
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    bodyStyles: { lineWidth: 0 },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: totalReserved },
    tableWidth: usableWidth,
    didDrawCell: (hookData) => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.line(hookData.cell.x, hookData.cell.y, hookData.cell.x, hookData.cell.y + hookData.cell.height);
      if (hookData.column.index === hookData.table.columns.length - 1) {
        doc.line(hookData.cell.x + hookData.cell.width, hookData.cell.y, hookData.cell.x + hookData.cell.width, hookData.cell.y + hookData.cell.height);
      }
      if (hookData.row.index === hookData.table.body.length - 1) {
        doc.line(hookData.cell.x, hookData.cell.y + hookData.cell.height, hookData.cell.x + hookData.cell.width, hookData.cell.y + hookData.cell.height);
      }
    },
  });

  const totalsStartY = doc.lastAutoTable.finalY;

  // ===== CALCULATION BLOCKS =====
  const grossAmount = data.reduce((sum, item) => {
    if (item.unit?.toUpperCase() === "FOC") return sum;
    const qty = Number(item.tr_qty2 || item.qty || 0);
    const unitPrice = Number(item.unit_price || item.funit_pric || 0);
    return sum + (qty * unitPrice);
  }, 0);

  const taxableAmount = grossAmount - discount;
  const vatStatusField = firstItem.deliv_site || firstItem.vatType || firstItem.vattype || firstItem.po_doc || "";
  const vatRate = vatStatusField === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = taxableAmount * (vatRate / 100);
  const roundOff = Number(firstItem.rdoff || 0);
  const grandTotal = taxableAmount + vatAmount + roundOff;

  // Render Totals Boundary Container
  doc.setDrawColor(0);
  doc.setLineWidth(0.1);
  doc.rect(margin, totalsStartY, contentWidth, calcTotalsBoxHeight);

  // Word Strings (Left Allocation)
  const dividerX = pageWidth / 2 + 10;
  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  const amountWords = convertAmountToWords(grandTotal, firstItem.fc || "AED");
  const wrappedWords = doc.splitTextToSize(amountWords, dividerX - margin - 4);
  doc.text(wrappedWords, margin + 2, totalsStartY + 7);

  // Totals Breakdown Structured Output (Right Allocation)
  const rightLabelX = dividerX + 3;
  const rightValueX = pageWidth - margin - 2;
  let rightY = totalsStartY + totalsRowH;

  doc.setFontSize(8.5);
  doc.text("Taxable Amount", rightLabelX, rightY);
  doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  if (discount !== 0) {
    doc.text("Discount :", rightLabelX, rightY);
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += totalsRowH;
  }

  doc.text(`Vat Amount (${vatRate}%)`, rightLabelX, rightY);
  doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += totalsRowH;

  if (roundOff !== 0) {
    doc.text("Round Off", rightLabelX, rightY);
    doc.text(roundOff.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += totalsRowH;
  }

  doc.setFont(undefined, "bold");
  doc.setFontSize(9);
  doc.text("Net Amount", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  // ===== REMARKS / SIGNATURE SEGMENTS =====
  const remarksStartY = totalsStartY + calcTotalsBoxHeight;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("REMARKS:", margin, remarksStartY + 6);
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(firstItem.remarks || "", margin + 20, remarksStartY + 6);

  const sigLineY = pageHeight - footerImgHeight - 8;
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text("RECEIVED BY", margin, sigLineY - 6);
  doc.text("PREPARED BY", pageWidth / 2, sigLineY - 6, { align: "center" });
  doc.text(`For ${COMPANY_NAME}`, pageWidth - margin, sigLineY - 6, { align: "right" });

  doc.setFont(undefined, "normal");
  doc.text("Sign & Date", margin, sigLineY);
  doc.text("Staff Signature", pageWidth / 2, sigLineY, { align: "center" });
  doc.text("Authorized Signatory", pageWidth - margin, sigLineY, { align: "right" });

  // Footer Placement Check
  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};

const PurchaseInvoiceWithOtherCosts = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  otherCosts = [],
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const FONT = "helvetica";
  const margin = 15;
  const contentWidth = pageWidth - 2 * margin;

  const BORDER_COLOR = [0, 0, 0];
  const BORDER_WIDTH = 0.1;

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 5;

  // ─── 1. Title ────────────────────────────────────────────────────────────────
  doc.setFontSize(13);
  doc.setFont(FONT, "bold");
  doc.text("PURCHASE INVOICE", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 12;

  // ─── 2. Supplier + Header Info ───────────────────────────────────────────────
  const rightLabelX = pageWidth - margin - 68;
  const rightValueX = pageWidth - margin - 44;
  const maxValueW = 44;
  const lineH = 4.8;

  doc.setFontSize(8.5);

  const headerInfo = [
    { label: "PINV NO", value: firstItem.inv_no || "" },
    { label: "P.ORD NO", value: firstItem.ref || "0" },
    {
      label: "DATE",
      value: firstItem.date
        ? new Date(firstItem.date).toLocaleDateString("en-GB")
        : "",
    },
    { label: "INV NO", value: firstItem.inv || "" },
    { label: "DOC REF", value: firstItem.docref || "" },
  ];

  const splitValues = headerInfo.map((info) =>
    doc.splitTextToSize(info.value, maxValueW),
  );

  // Customer Name (Wrap if long)
  doc.setFont(FONT, "bold");
  doc.setFontSize(9);

  const customerName = firstItem.accdesc || "";

  // Wrap name to left-side width
  const nameLines = doc.splitTextToSize(customerName, rightLabelX - margin - 5);

  // Print wrapped name
  doc.text(nameLines, margin, yPosition);

  // === Build Full Address ===
  const fullAddress = [
    firstItem.address1?.trim(),
    firstItem.address2?.trim(),
    firstItem.address3?.trim(),
  ]
    .filter((addr) => addr && addr !== "")
    .join(", ");

  // Wrap address
  doc.setFont(FONT, "normal");
  doc.setFontSize(8);

  const addressLines = doc.splitTextToSize(
    fullAddress,
    rightLabelX - margin - 5,
  );

  // === Phone Line ===
  const phoneText = `Tel: ${firstItem.phone || "-"}`;

  const addressStartY = yPosition + nameLines.length * lineH;

  doc.text(addressLines, margin, addressStartY);
  const phoneStartY = addressStartY + addressLines.length * lineH;

  doc.text(phoneText, margin, phoneStartY);
  // Adjust right side starting Y
  let rightY = yPosition;
  headerInfo.forEach((info, i) => {
    const lines = splitValues[i];

    doc.setFont(FONT, "bold");
    doc.setFontSize(8.5);
    doc.text(info.label, rightLabelX, rightY);

    doc.setFont(FONT, "normal");
    doc.text(":", rightValueX - 5, rightY);
    doc.text(lines, rightValueX, rightY);

    rightY += lines.length * lineH;
  });

  const leftHeight = (nameLines.length + addressLines.length + 1) * lineH; // +1 for phone
  const leftStart = yPosition + leftHeight;

  yPosition = Math.max(rightY, leftStart) + 3;
  // ─── 3. Purchase Type ────────────────────────────────────────────────────────
  doc.setFontSize(8.5);
  doc.setFont(FONT, "normal");
  doc.text("PURCH. TYPE:", margin, yPosition);
  doc.setFont(FONT, "bold");
  doc.text(
    firstItem.local === "I" ? "IMPORT" : "LOCAL",
    margin + 27,
    yPosition,
  );
  yPosition += 6;

  // ─── 4. Amount Summary Row ───────────────────────────────────────────────────
  const totalOtherCost = otherCosts.reduce(
    (sum, c) =>
      sum + Number(c.amount || c.curamount || 0) * Number(c.rate || 1),
    0,
  );
  const fcAmount = Number(firstItem.amount || 0);
  const fcRate = Number(firstItem.rate || 1);
  const totalAED = fcAmount * fcRate;

  doc.setDrawColor(...BORDER_COLOR);
  doc.setLineWidth(BORDER_WIDTH);
  doc.rect(margin, yPosition - 3.5, contentWidth, 8);

  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);

  const amtY = yPosition + 1;
  let cursorX = margin + 2;

  // AMOUNT label + bold value
  doc.setFont(FONT, "normal");
  doc.text("AMOUNT  :  ", cursorX, amtY);
  doc.setFont(FONT, "bold");
  doc.text(
    `${firstItem.fc || "AED"} ${fcAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
    cursorX + doc.getTextWidth("AMOUNT  :  "),
    amtY,
  );

  // FC RATE label + bold value
  cursorX = margin + 60;
  doc.setFont(FONT, "normal");
  doc.text("FC RATE  :  ", cursorX, amtY);
  doc.setFont(FONT, "bold");
  doc.text(fcRate.toFixed(2), cursorX + doc.getTextWidth("FC RATE  :  "), amtY);

  // OTHER COST label + bold value
  cursorX = margin + 100;
  doc.setFont(FONT, "normal");
  doc.text("OTHER COST  :  ", cursorX, amtY);
  doc.setFont(FONT, "bold");
  doc.text(
    totalOtherCost.toLocaleString(undefined, { minimumFractionDigits: 2 }),
    cursorX + doc.getTextWidth("OTHER COST  :  "),
    amtY,
  );

  // AMOUNT AED — label normal, value bold, right-aligned
  const aedValue = totalAED.toLocaleString(undefined, {
    minimumFractionDigits: 2,
  });
  const aedLabel = "AMOUNT AED:  ";
  doc.setFont(FONT, "bold");
  const aedValueW = doc.getTextWidth(aedValue);
  doc.setFont(FONT, "normal");

  const aedRightEdge = pageWidth - margin - 2;
  doc.setFont(FONT, "bold");
  doc.text(aedValue, aedRightEdge, amtY, { align: "right" });
  doc.setFont(FONT, "normal");
  doc.text(aedLabel, aedRightEdge - aedValueW, amtY, { align: "right" });

  yPosition += 10;

  // ─── 5. Amount in Words ──────────────────────────────────────────────────────
  doc.setFontSize(7.5);
  doc.setFont(FONT, "normal");
  doc.setTextColor(0, 0, 0);

  const fcWords = convertAmountToWords(
    fcAmount,
    firstItem.fc || "USD",
  ).toUpperCase();
  const aedWords = convertAmountToWords(totalAED, "AED").toUpperCase();

  doc.text(fcWords, margin, yPosition);
  yPosition += 5;
  doc.text(aedWords, margin, yPosition);
  yPosition += 4;

  // ─── 6. Items Table ──────────────────────────────────────────────────────────
  const columns = [
    { header: "SINO", ratio: 0.045 },
    { header: "CODE", ratio: 0.105 },
    { header: "DESCRIPTION", ratio: 0.3 },
    { header: "QTY", ratio: 0.07 },
    { header: "RATE", ratio: 0.085 },
    { header: "AED", ratio: 0.085 },
    { header: "O.C", ratio: 0.075 },
    { header: "LCOST", ratio: 0.08 },
    { header: "TOTAL COST", ratio: 0.155 },
  ];
  const numCols = columns.length;

  const tableBody = data.map((item, idx) => {
    const qty = Number(item.qty || item.tr_qty2 || 0);
    const rate = Number(item.funit_pric || item.rate || 0);
    const aed = rate * fcRate;
    const lineOtherCost = Number(item.POTHERCOST || 0);
    const ocPerUnit = qty > 0 ? lineOtherCost / qty : 0;
    const landedCost = aed + ocPerUnit;
    const totalLineCost = qty * landedCost;

    return [
      idx + 1,
      item.code || "",
      item.idesc || item.itemdesc || "",
      qty.toString(),
      rate.toFixed(2),
      aed.toFixed(2),
      ocPerUnit.toFixed(2),
      landedCost.toFixed(2),
      totalLineCost.toFixed(2),
    ];
  });

  autoTable(doc, {
    head: [columns.map((c) => c.header)],
    body: tableBody,
    startY: yPosition,
    theme: "plain",
    styles: {
      fontSize: 7,
      font: FONT,
      textColor: [0, 0, 0],
      cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
      lineWidth: 0,
      fillColor: false,
    },
    headStyles: {
      font: FONT,
      fontStyle: "bold",
      halign: "center",
      fillColor: false,
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    bodyStyles: { fillColor: false },
    columnStyles: {
      0: { halign: "center" },
      2: {
        // ← DESCRIPTION column
        cellPadding: { top: 3.5, bottom: 3.5, left: 2, right: 2 },
        lineHeightFactor: 1.6, // ← more space between wrapped lines
      },
      3: { halign: "center" },
      4: { halign: "right" },
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
      8: { halign: "right" },
    },
    tableLineWidth: BORDER_WIDTH,
    tableLineColor: BORDER_COLOR,
    margin: { left: margin, right: margin },
    showHead: "everyPage",
    didDrawCell: (hookData) => {
      const { doc: d, cell, column, row } = hookData;
      const isLastCol = column.index === numCols - 1;
      const isHeader = row.section === "head";

      d.setDrawColor(...BORDER_COLOR);
      d.setLineWidth(BORDER_WIDTH);

      if (!isLastCol) {
        d.line(
          cell.x + cell.width,
          cell.y,
          cell.x + cell.width,
          cell.y + cell.height,
        );
      }
      if (isHeader) {
        d.line(
          cell.x,
          cell.y + cell.height,
          cell.x + cell.width,
          cell.y + cell.height,
        );
      }
    },
    didDrawPage: (hookData) => {
      if (REPORT_HEADER_IMAGE && hookData.pageNumber > 1) {
        drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE);
      }
    },
  });

  yPosition = doc.lastAutoTable.finalY + 8;

  // ─── 7. Other Cost Information ───────────────────────────────────────────────
  doc.setFontSize(8.5);
  doc.setFont(FONT, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("OTHER COST INFORMATION", margin, yPosition);
  yPosition += 2;

  const expenseBody = otherCosts.map((cost) => [
    cost.account || "",
    cost.costc || "STOCK",
    cost.ref || cost.ttref || "-",
    (
      Number(cost.amount || cost.curamount || 0) * Number(cost.rate || 1)
    ).toFixed(2),
  ]);

  autoTable(doc, {
    head: [["ACCOUNT", "ACCOUNT DESCRIPTION", "DETAILS", "AMOUNT"]],
    body: expenseBody,
    startY: yPosition,
    theme: "plain",
    styles: {
      fontSize: 7,
      font: FONT,
      textColor: [0, 0, 0],
      cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
      lineWidth: 0,
      fillColor: false,
    },
    headStyles: {
      font: FONT,
      fontStyle: "bold",
      fillColor: false,
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    bodyStyles: { fillColor: false },
    columnStyles: { 3: { halign: "right" } },
    tableLineWidth: BORDER_WIDTH,
    tableLineColor: BORDER_COLOR,
    margin: { left: margin, right: margin },
    showHead: "everyPage",
    didDrawCell: (hookData) => {
      const { doc: d, cell, column, row } = hookData;
      const isLastCol = column.index === 3;
      const isHeader = row.section === "head";

      d.setDrawColor(...BORDER_COLOR);
      d.setLineWidth(BORDER_WIDTH);

      if (!isLastCol) {
        d.line(
          cell.x + cell.width,
          cell.y,
          cell.x + cell.width,
          cell.y + cell.height,
        );
      }
      if (isHeader) {
        d.line(
          cell.x,
          cell.y + cell.height,
          cell.x + cell.width,
          cell.y + cell.height,
        );
      }
    },
  });

  yPosition = doc.lastAutoTable.finalY + 10;

  // ─── 8. Net Total Summary ────────────────────────────────────────────────────
  const summaryBlockHeight = 30;
  if (yPosition + summaryBlockHeight > pageHeight - 20) {
    doc.addPage();
    yPosition =
      (REPORT_HEADER_IMAGE
        ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
        : 0) + 10;
  }

  const totalCostSum = tableBody.reduce((sum, row) => sum + Number(row[8]), 0);
  const discount = Number(firstItem.discount || 0);
  const vatAmount = Number(firstItem.vat_amount || firstItem.vatamt || 0);
  const netTotal = totalCostSum - discount + vatAmount;

  // Words box
  doc.setDrawColor(...BORDER_COLOR);
  doc.setLineWidth(BORDER_WIDTH);
  doc.rect(margin, yPosition, contentWidth * 0.58, 22);

  doc.setFontSize(7.5);
  doc.setFont(FONT, "normal");
  const netWords = convertAmountToWords(
    netTotal,
    otherCosts[0]?.fc || "AED",
  ).toUpperCase();
  doc.text(
    doc.splitTextToSize(netWords, contentWidth * 0.54),
    margin + 2,
    yPosition + 5,
  );

  // Summary lines (right)
  const totalLabelX = margin + contentWidth * 0.63;
  const totalValueX = pageWidth - margin - 2;

  const summary = [
    { label: "TOTAL", value: totalCostSum.toFixed(2) },
    { label: "DISCOUNT", value: discount.toFixed(2) },
    { label: "VAT AMOUNT", value: vatAmount.toFixed(2) },
    { label: "NET TOTAL", value: netTotal.toFixed(2), bold: true },
  ];

  doc.setFontSize(8);
  summary.forEach((item, i) => {
    const rowY = yPosition + i * 5.5;
    doc.setFont(FONT, item.bold ? "bold" : "normal");
    doc.text(item.label, totalLabelX, rowY);
    doc.text(item.value, totalValueX, rowY, { align: "right" });
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(0.2);
    doc.line(totalLabelX, rowY + 1.5, totalValueX, rowY + 1.5);
  });

  // ─── 9. Signatures ───────────────────────────────────────────────────────────
  yPosition += 38;

  if (yPosition + 20 > pageHeight - 15) {
    doc.addPage();
    yPosition =
      (REPORT_HEADER_IMAGE
        ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
        : 0) + 15;
  }

  const sigLineY = yPosition - 5;
  const sigW = 40;

  doc.setDrawColor(...BORDER_COLOR);
  doc.setLineWidth(BORDER_WIDTH);
  doc.line(margin, sigLineY, margin + sigW, sigLineY);
  doc.line(
    pageWidth / 2 - sigW / 2,
    sigLineY,
    pageWidth / 2 + sigW / 2,
    sigLineY,
  );
  doc.line(pageWidth - margin - sigW, sigLineY, pageWidth - margin, sigLineY);

  doc.setFontSize(8.5);
  doc.setFont(FONT, "normal");
  doc.setTextColor(0, 0, 0);
  doc.text("Prepared By", margin, yPosition);
  doc.text("Verified By", pageWidth / 2, yPosition, { align: "center" });
  doc.text("Approved By", pageWidth - margin, yPosition, { align: "right" });

  yPosition += 15;
};

// Generic Layout without Header (WITH HEADER AND FOOTER)
const GenericWithoutHeaderLayoutPrint = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  includeCode = false,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  // Draw header
  const headerHeight = drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE);
  let yPosition = headerHeight + 10;

  // ==== Title ====
  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(config.title, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  // ==== Company Info & Document Info Boxes ====
  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const companyBoxWidth = contentWidth * 0.7;
  const boxHeight = 25;

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");

  const addressLines = doc.splitTextToSize(
    firstItem.address2 || "-",
    companyBoxWidth - 4,
  );

  const lineHeight = 6;

  const companyBoxHeight = 8 + 6 + addressLines.length * lineHeight + 6;

  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.tr_desc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.text(`TEL: ${firstItem.tel || "-"}`, margin + 2, yPosition + 14);

  let addressY = yPosition + 20;
  doc.text(addressLines, margin + 2, addressY);

  doc.setFont(undefined, "bold");
  const trnY = addressY + addressLines.length * lineHeight;
  doc.text(
    `${VATMODE === "SAUDIPHASE1" || VATMODE === "SAUDIPHASE2"
      ? "Client Vat Reg No"
      : "CLIENT TRN"
    }: ${firstItem.governor || "-"}`,
    margin + 2,
    trnY,
  );

  const detailsX = margin + companyBoxWidth + boxGap;
  const labelX = detailsX + 2;
  const valueX = detailsX + 20;
  let detailsY = yPosition + 5;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(config.numberLabel, labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem[config.numberField]?.toString() || firstItem.q_no || "",
    valueX,
    detailsY,
  );

  detailsY += 5;
  doc.setFont(undefined, "normal");
  doc.text(config.dateLabel, labelX, detailsY);
  const docDate = firstItem[config.dateField]
    ? new Date(firstItem[config.dateField]).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailsY);

  config.detailFields.forEach((field) => {
    detailsY += 5;
    doc.setFont(undefined, "normal");
    doc.text(field.label, labelX, detailsY);
    doc.setFont(undefined, "bold");
    doc.text(firstItem[field.field]?.toString() || "-", valueX, detailsY);
  });

  yPosition += boxHeight + 10;

  // ==== Table Section ====
  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = includeCode
    ? config.columns.withCode
    : config.columns.withoutCode;
  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = generateTableRows(data, config, includeCode, VATPERCENTAGE);

  const tableStartY = yPosition;
  const footerHeight = 35;
  const spaceForTable = config.showPricing
    ? pageHeight - footerHeight - 160
    : pageHeight - footerHeight - 140;
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (spaceForTable - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: 70 },
    tableWidth: includeCode ? "auto" : usableWidth,
    didDrawCell: (data) => {
      doc.setDrawColor(180);
      doc.setLineWidth(0.1);
      doc.line(
        data.cell.x,
        data.cell.y,
        data.cell.x,
        data.cell.y + data.cell.height,
      );
      if (data.column.index === data.table.columns.length - 1) {
        doc.line(
          data.cell.x + data.cell.width,
          data.cell.y,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
      if (data.row.index === data.table.body.length - 1) {
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 5;

  // ==== Totals Section ====
  if (config.showPricing) {
    const grossAmount = data.reduce((sum, item) => {
      // Check FOC item
      const isFOC =
        item.foc === 1 ||
        item.foc === true ||
        item.unit?.toUpperCase() === "FOC" ||
        item.freeQty > 0;

      if (isFOC) {
        return sum;
      }

      const qty = item.tr_qty || item.so_qty || item.qty || 0;

      const unitCost =
        item.unit_cost || item.unit_ppric || item.rate || item.unitPrice || item.so_cost || 0;
      return sum + qty * unitCost;
    }, 0);

    const discount = firstItem.discount || firstItem.disc_amt || 0;
    const taxableAmount = grossAmount - discount;
    const vatRate = firstItem.deliv_site === "VAT Applied" ? VATPERCENTAGE : 0;
    const isAdvancePayment = firstItem.awb?.trim().toUpperCase() === "ADVANCE";
    const advanceAmount = isAdvancePayment ? Number(firstItem.inv_qty || 0) : 0;
    const balanceClaiming = isAdvancePayment && advanceAmount > 0 ? taxableAmount - advanceAmount : taxableAmount;
    const vatAmount = balanceClaiming * (vatRate / 100);
    const grandTotal = balanceClaiming + vatAmount;

    const boxMargin = 15;
    const boxWidth = pageWidth - 2 * boxMargin;
    const boxHeight = isAdvancePayment && advanceAmount > 0 ? 48 : 35;
    const boxStartY = currentY;

    doc.setDrawColor(180);
    doc.setLineWidth(0.1);
    doc.rect(boxMargin, boxStartY, boxWidth, boxHeight);

    const leftX = boxMargin + 3;
    const leftMaxWidth = pageWidth / 2 - boxMargin - 10;
    let leftY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("Amount in Words:", leftX, leftY);
    leftY += 5;
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);

    const amountInWords = convertAmountToWords(
      grandTotal,
      firstItem.fc || "AED",
    );
    const amountLines = doc.splitTextToSize(amountInWords, leftMaxWidth);
    doc.text(amountLines, leftX, leftY);
    leftY += amountLines.length * 4;

    if (COMPANY_NAME === "SHUROOQ AL WAHHA TRADING CO.") {
      leftY += 3;
      doc.setFontSize(9);
      doc.setFont(undefined, "bold");
      doc.text("Bank Name:", leftX, leftY);
      doc.setFont(undefined, "normal");
      doc.text("ALRAJHI BANK", leftX + 30, leftY);

      leftY += 5;
      doc.setFont(undefined, "bold");
      doc.text("IBAN:", leftX, leftY);
      doc.setFont(undefined, "normal");
      doc.text("SA5780000458608015855007", leftX + 30, leftY);

      leftY += 5;
      doc.setFont(undefined, "bold");
      doc.text("Account Number:", leftX, leftY);
      doc.setFont(undefined, "normal");
      doc.text("458000010006085855007", leftX + 30, leftY);
    } else {
      leftY += 3;
      doc.setFontSize(9);
      doc.setFont(undefined, "bold");
      doc.text("Payment:", leftX, leftY);
      doc.setFont(undefined, "normal");
      doc.text(firstItem.payment_terms || "-", leftX + 20, leftY);

      leftY += 5;
      doc.setFont(undefined, "bold");
      doc.text("Delivery:", leftX, leftY);
      doc.setFont(undefined, "normal");
      doc.text(firstItem.delivery_terms || "-", leftX + 20, leftY);
    }

    const rightLabelX = pageWidth / 2 + 10;
    const rightValueX = pageWidth - boxMargin - 3;
    let rightY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    doc.text("Gross Amount:", rightLabelX, rightY);
    doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Discount:", rightLabelX, rightY);
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Sub Total:", rightLabelX, rightY);
    doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    if (isAdvancePayment && advanceAmount > 0) {
      doc.text("Advance Amount:", rightLabelX, rightY);
      doc.text(advanceAmount.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;

      doc.text("Balance Claiming:", rightLabelX, rightY);
      doc.text(balanceClaiming.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;
    }

    doc.text(`VAT (${vatRate}%):`, rightLabelX, rightY);
    doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.setFontSize(10);
    doc.text("Net Total:", rightLabelX, rightY);
    doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

    currentY = boxStartY + boxHeight + 5;
  } else {
    currentY += 10;
  }

  // ==== Remarks ====
  if (config.title !== "DELIVERY ORDER") {
    const bottomY = pageHeight - 65;
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("REMARKS:", 15, bottomY);
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(firstItem.remarks || "-", 15, bottomY + 5);
  }

  // ==== Signature Section ====
  const sigY = pageHeight - 40;
  doc.setFontSize(9);

  if (config.title === "DELIVERY ORDER") {
    const startX = 15;
    const tableWidth = 90;

    const rowHeight = 6;
    const signatureRowHeight = 12;

    const totalBoxHeight = rowHeight * 2 + signatureRowHeight;

    const startY = sigY - 10;
    const rightAlignX = pageWidth - 15;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);

    doc.text("Received all goods in good condition", startX, startY - 3);

    // Outer box
    doc.rect(startX, startY, tableWidth, totalBoxHeight);

    // Row separator lines
    doc.line(
      startX,
      startY + rowHeight,
      startX + tableWidth,
      startY + rowHeight,
    );

    doc.line(
      startX,
      startY + rowHeight * 2,
      startX + tableWidth,
      startY + rowHeight * 2,
    );

    // Labels
    doc.setFont(undefined, "bold");

    const textOffset = 4.5;

    doc.text("Receiver Name:", startX + 2, startY + textOffset);

    doc.text("Phone:", startX + 2, startY + rowHeight + textOffset);

    doc.text("Signature:", startX + 2, startY + rowHeight * 2 + textOffset);

    // Seal centered
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20;
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    // Right section
    doc.setFont(undefined, "normal");

    const rightSectionStartY = startY + 4;

    // 🔥 Increase spacing here
    const preparedVerifiedSpacing = 14;

    doc.text(
      "Prepared by: __________________",
      rightAlignX,
      rightSectionStartY,
      { align: "right" },
    );

    doc.text(
      "Verified by: __________________",
      rightAlignX,
      rightSectionStartY + preparedVerifiedSpacing,
      { align: "right" },
    );

    doc.setFont(undefined, "bold");

    doc.text(
      `For ${COMPANY_NAME}`,
      rightAlignX,
      startY + rowHeight * 2 + signatureRowHeight + 6,
      { align: "right" },
    );

    doc.setFontSize(7);
  } else {
    // Non-delivery order: seal centered above the signature line
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20; // Reduced size from 25 to 20
      // Right block text is right-aligned at (pageWidth - 15). 
      // Subtracting 35 centers a 20px image comfortably above that alignment space.
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    doc.setFont(undefined, "bold");
    doc.text(config.footerLeft || "PREPARED BY", 15, sigY);
    doc.text("AUTHORIZED BY", pageWidth / 2, sigY, { align: "center" });
    doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, sigY, { align: "right" });
  }

  // ==== Footer on all pages ====
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
  }
};

// Generic Layout without Header, No Balance Due
const GenericWithoutHeaderLayoutPrintNoBalance = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  includeCode = false,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const headerHeight = drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE);
  let yPosition = headerHeight + 10;

  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(config.title, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const companyBoxWidth = contentWidth * 0.7;
  const boxHeight = 25;

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");

  const addressLines = doc.splitTextToSize(
    firstItem.address2 || "-",
    companyBoxWidth - 4,
  );

  const lineHeight = 6;

  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.tr_desc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.text(`TEL: ${firstItem.tel || "-"}`, margin + 2, yPosition + 14);

  let addressY = yPosition + 20;
  doc.text(addressLines, margin + 2, addressY);

  doc.setFont(undefined, "bold");
  const trnY = addressY + addressLines.length * lineHeight;
  doc.text(
    `${VATMODE === "SAUDIPHASE1" || VATMODE === "SAUDIPHASE2"
      ? "Client Vat Reg No"
      : "CLIENT TRN"
    }: ${firstItem.governor || "-"}`,
    margin + 2,
    trnY,
  );

  const detailsX = margin + companyBoxWidth + boxGap;
  const labelX = detailsX + 2;
  const valueX = detailsX + 20;
  let detailsY = yPosition + 5;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(config.numberLabel, labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem[config.numberField]?.toString() || firstItem.q_no || "",
    valueX,
    detailsY,
  );

  detailsY += 5;
  doc.setFont(undefined, "normal");
  doc.text(config.dateLabel, labelX, detailsY);
  const docDate = firstItem[config.dateField]
    ? new Date(firstItem[config.dateField]).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailsY);

  config.detailFields.forEach((field) => {
    detailsY += 5;
    doc.setFont(undefined, "normal");
    doc.text(field.label, labelX, detailsY);
    doc.setFont(undefined, "bold");
    doc.text(firstItem[field.field]?.toString() || "-", valueX, detailsY);
  });

  yPosition += boxHeight + 10;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = includeCode
    ? config.columns.withCode
    : config.columns.withoutCode;
  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = generateTableRows(data, config, includeCode, VATPERCENTAGE);

  const tableStartY = yPosition;
  const footerHeight = 20;
  const spaceForTable = config.showPricing
    ? pageHeight - footerHeight - 160
    : pageHeight - footerHeight - 140;
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (spaceForTable - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: 70 },
    tableWidth: includeCode ? "auto" : usableWidth,
    didDrawCell: (data) => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.line(
        data.cell.x,
        data.cell.y,
        data.cell.x,
        data.cell.y + data.cell.height,
      );
      if (data.column.index === data.table.columns.length - 1) {
        doc.line(
          data.cell.x + data.cell.width,
          data.cell.y,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
      if (data.row.index === data.table.body.length - 1) {
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 5;

  // ==== Totals Section - WITH ADVANCE, WITHOUT BALANCE ====
  if (config.showPricing) {
    const grossAmount = data.reduce((sum, item) => {
      // Check FOC item
      const isFOC =
        item.foc === 1 ||
        item.foc === true ||
        item.unit?.toUpperCase() === "FOC" ||
        item.freeQty > 0;

      if (isFOC) {
        return sum;
      }

      const qty = item.tr_qty || item.so_qty || item.qty || 0;

      const unitCost =
        item.unit_cost || item.unit_ppric || item.rate || item.unitPrice || 0;

      return sum + qty * unitCost;
    }, 0);

    const discount = firstItem.discount || firstItem.disc_amt || 0;
    const taxableAmount = grossAmount - discount;
    const vatRate = firstItem.deliv_site === "VAT Applied" ? VATPERCENTAGE : 0;
    const isAdvancePayment = firstItem.awb?.trim().toUpperCase() === "ADVANCE";
    const advanceAmount = isAdvancePayment ? Number(firstItem.inv_qty || 0) : 0;
    const balanceClaiming = isAdvancePayment && advanceAmount > 0 ? taxableAmount - advanceAmount : taxableAmount;
    const vatAmount = balanceClaiming * (vatRate / 100);
    const grandTotal = balanceClaiming + vatAmount;

    const boxMargin = 15;
    const boxWidth = pageWidth - 2 * boxMargin;
    const boxHeight = isAdvancePayment && advanceAmount > 0 ? 48 : 35;
    const boxStartY = currentY;

    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(boxMargin, boxStartY, boxWidth, boxHeight);

    const leftX = boxMargin + 3;
    const leftMaxWidth = pageWidth / 2 - boxMargin - 10;
    let leftY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("Amount in Words:", leftX, leftY);
    leftY += 5;
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);

    const amountInWords = convertAmountToWords(
      grandTotal,
      firstItem.fc || "AED",
    );
    const amountLines = doc.splitTextToSize(amountInWords, leftMaxWidth);
    doc.text(amountLines, leftX, leftY);
    leftY += amountLines.length * 4;

    leftY += 3;
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("Payment:", leftX, leftY);
    doc.setFont(undefined, "normal");
    doc.text(firstItem.payment_terms || "-", leftX + 20, leftY);

    leftY += 5;
    doc.setFont(undefined, "bold");
    doc.text("Delivery:", leftX, leftY);
    doc.setFont(undefined, "normal");
    doc.text(firstItem.delivery_terms || "-", leftX + 20, leftY);

    const rightLabelX = pageWidth / 2 + 10;
    const rightValueX = pageWidth - boxMargin - 3;
    let rightY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    doc.text("Gross Amount:", rightLabelX, rightY);
    doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Discount:", rightLabelX, rightY);
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Sub Total:", rightLabelX, rightY);
    doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    if (isAdvancePayment && advanceAmount > 0) {
      doc.text("Advance Amount:", rightLabelX, rightY);
      doc.text(advanceAmount.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;

      doc.text("Balance Claiming:", rightLabelX, rightY);
      doc.text(balanceClaiming.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;
    }

    doc.text(`VAT (${vatRate}%):`, rightLabelX, rightY);
    doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.setFontSize(10);
    doc.text("Net Total:", rightLabelX, rightY);
    doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

    currentY = boxStartY + boxHeight + 5;
  } else {
    currentY += 10;
  }

  // ==== Remarks ====
  if (config.title !== "DELIVERY ORDER") {
    const bottomY = pageHeight - 65;
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("REMARKS:", 15, bottomY);
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(firstItem.remarks || "-", 15, bottomY + 5);
  }

  // ==== Signature Section ====
  const sigY = pageHeight - 40;
  doc.setFontSize(9);

  if (config.title === "DELIVERY ORDER") {
    const startX = 15;
    const tableWidth = 90;
    const rowHeight = 6;
    const totalBoxHeight = rowHeight * 3;
    const startY = sigY - 10;
    const rightAlignX = pageWidth - 15;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text("Received all goods in good condition", startX, startY - 3);

    doc.rect(startX, startY, tableWidth, totalBoxHeight);

    for (let i = 1; i < 3; i++) {
      doc.line(
        startX,
        startY + rowHeight * i,
        startX + tableWidth,
        startY + rowHeight * i,
      );
    }

    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    const textOffset = 4.5;
    doc.text("Receiver Name:", startX + 2, startY + textOffset);
    doc.text("Phone:", startX + 2, startY + rowHeight + textOffset);
    doc.text("Signature:", startX + 2, startY + rowHeight * 2 + textOffset);

    // Seal - centered on page
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20; // Reduced size from 25 to 20
      // Right block text is right-aligned at (pageWidth - 15). 
      // Subtracting 35 centers a 20px image comfortably above that alignment space.
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    const rightSectionStartY = startY + 4;
    const extraMargin = 6;

    doc.text(
      "Prepared by: __________________",
      rightAlignX,
      rightSectionStartY,
      { align: "right" },
    );
    doc.text(
      "Verified by: __________________",
      rightAlignX,
      rightSectionStartY + rowHeight,
      { align: "right" },
    );

    doc.setFont(undefined, "bold");
    doc.text(
      `For ${COMPANY_NAME}`,
      rightAlignX,
      rightSectionStartY + rowHeight * 2 + extraMargin,
      { align: "right" },
    );

    doc.setFontSize(7);
  } else {
    // Non-delivery order: seal centered above the signature line
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20; // Reduced size from 25 to 20
      // Right block text is right-aligned at (pageWidth - 15). 
      // Subtracting 35 centers a 20px image comfortably above that alignment space.
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    doc.setFont(undefined, "bold");
    doc.text(config.footerLeft || "PREPARED BY", 15, sigY);
    doc.text("AUTHORIZED BY", pageWidth / 2, sigY, { align: "center" });
    doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, sigY, { align: "right" });
  }

  // ==== Footer on all pages ====
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
  }
};

// Generic Layout with Header (Pre-printed paper)
const GenericWithHeaderLayoutPrint = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  includeCode = false,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const topMargin = 45;
  const bottomMargin = 35;
  let yPosition = topMargin;

  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.text(config.title, pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const companyBoxWidth = contentWidth * 0.7;
  const boxHeight = 25;

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.tr_desc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.text(`TEL: ${firstItem.tel || "-"}`, margin + 2, yPosition + 14);
  doc.text(firstItem.address2 || "-", margin + 2, yPosition + 20);

  doc.setFont(undefined, "bold");
  doc.text(
    `${VATMODE === "SAUDIPHASE1" || VATMODE === "SAUDIPHASE2"
      ? "Client Vat Reg No"
      : "CLIENT TRN"
    }: ${firstItem.governor || "-"}`,
    margin + 2,
    yPosition + 27,
  );

  const detailsX = margin + companyBoxWidth + boxGap;
  const labelX = detailsX + 2;
  const valueX = detailsX + 20;
  let detailsY = yPosition + 5;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(config.numberLabel, labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem[config.numberField]?.toString() || firstItem.q_no || "",
    valueX,
    detailsY,
  );

  detailsY += 5;
  doc.setFont(undefined, "normal");
  doc.text(config.dateLabel, labelX, detailsY);
  const docDate = firstItem[config.dateField]
    ? new Date(firstItem[config.dateField]).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailsY);

  config.detailFields.forEach((field) => {
    detailsY += 5;
    doc.setFont(undefined, "normal");
    doc.text(field.label, labelX, detailsY);
    doc.setFont(undefined, "bold");
    doc.text(firstItem[field.field]?.toString() || "-", valueX, detailsY);
  });

  yPosition += boxHeight + 10;

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = includeCode
    ? config.columns.withCode
    : config.columns.withoutCode;
  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = generateTableRows(data, config, includeCode);

  const tableStartY = yPosition;
  const usableHeight =
    pageHeight - bottomMargin - tableStartY - (config.showPricing ? 80 : 60);
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (usableHeight - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles,
    margin: {
      left: leftMargin,
      right: rightMargin,
      top: topMargin,
      bottom: 70,
    },
    tableWidth: includeCode ? "auto" : usableWidth,
    didDrawCell: (data) => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.line(
        data.cell.x,
        data.cell.y,
        data.cell.x,
        data.cell.y + data.cell.height,
      );
      if (data.column.index === data.table.columns.length - 1) {
        doc.line(
          data.cell.x + data.cell.width,
          data.cell.y,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
      if (data.row.index === data.table.body.length - 1) {
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 5;

  // ==== Totals Section ====
  if (config.showPricing) {
    const grossAmount = data.reduce((sum, item) => {
      const qty = item.tr_qty || item.so_qty || 0;
      const unitCost = item.unit_cost || item.unit_ppric || item.rate || 0;
      return sum + qty * unitCost;
    }, 0);

    const discount = firstItem.discount || firstItem.disc_amt || 0;
    const taxableAmount = grossAmount - discount;
    const vatRate = firstItem.deliv_site === "VAT Applied" ? VATPERCENTAGE : 0;
    const isAdvancePayment = firstItem.awb?.trim().toUpperCase() === "ADVANCE";
    const advanceAmount = isAdvancePayment ? Number(firstItem.inv_qty || 0) : 0;
    const balanceClaiming = isAdvancePayment && advanceAmount > 0 ? taxableAmount - advanceAmount : taxableAmount;
    const vatAmount = balanceClaiming * (vatRate / 100);
    const grandTotal = balanceClaiming + vatAmount;

    const boxMargin = 15;
    const boxWidth = pageWidth - 2 * boxMargin;
    const boxHeight = isAdvancePayment && advanceAmount > 0 ? 48 : 35;
    const boxStartY = currentY;

    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(boxMargin, boxStartY, boxWidth, boxHeight);

    const leftX = boxMargin + 3;
    const leftMaxWidth = pageWidth / 2 - boxMargin - 10;
    let leftY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("Amount in Words:", leftX, leftY);
    leftY += 5;
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    const amountInWords = convertAmountToWords(
      grandTotal,
      firstItem.fc || "AED",
    );
    const amountLines = doc.splitTextToSize(amountInWords, leftMaxWidth);
    doc.text(amountLines, leftX, leftY);
    leftY += amountLines.length * 4;

    leftY += 3;
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("Payment:", leftX, leftY);
    doc.setFont(undefined, "normal");
    doc.text(firstItem.payment_terms || "-", leftX + 20, leftY);

    leftY += 5;
    doc.setFont(undefined, "bold");
    doc.text("Delivery:", leftX, leftY);
    doc.setFont(undefined, "normal");
    doc.text(firstItem.delivery_terms || "-", leftX + 20, leftY);

    const rightLabelX = pageWidth / 2 + 10;
    const rightValueX = pageWidth - boxMargin - 3;
    let rightY = boxStartY + 6;

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    doc.text("Gross Amount:", rightLabelX, rightY);
    doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Discount:", rightLabelX, rightY);
    doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.text("Sub Total:", rightLabelX, rightY);
    doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    if (isAdvancePayment && advanceAmount > 0) {
      doc.text("Advance Amount:", rightLabelX, rightY);
      doc.text(advanceAmount.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;

      doc.text("Balance Claiming:", rightLabelX, rightY);
      doc.text(balanceClaiming.toFixed(2), rightValueX, rightY, { align: "right" });
      rightY += 0.5;
      doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
      rightY += 3.5;
    }

    doc.text(`VAT (${vatRate}%):`, rightLabelX, rightY);
    doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });
    rightY += 0.5;
    doc.line(rightLabelX + 50, rightY, rightValueX, rightY);
    rightY += 3.5;

    doc.setFontSize(10);
    doc.text("Net Total:", rightLabelX, rightY);
    doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

    currentY = boxStartY + boxHeight + 5;
  } else {
    currentY += 10;
  }

  // ==== Remarks ====
  if (config.title !== "DELIVERY ORDER") {
    const bottomY = pageHeight - 65;
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.text("REMARKS:", 15, bottomY);
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(firstItem.remarks || "-", 15, bottomY + 5);
  }

  // ==== Signature Section ====
  const sigY = pageHeight - 40;
  doc.setFontSize(9);

  if (config.title === "DELIVERY ORDER") {
    const startX = 15;
    const tableWidth = 90;
    const rowHeight = 6;
    const totalBoxHeight = rowHeight * 3;
    const startY = sigY - 10;
    const rightAlignX = pageWidth - 15;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text("Received all goods in good condition", startX, startY - 3);

    doc.rect(startX, startY, tableWidth, totalBoxHeight);

    for (let i = 1; i < 3; i++) {
      doc.line(
        startX,
        startY + rowHeight * i,
        startX + tableWidth,
        startY + rowHeight * i,
      );
    }

    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    const textOffset = 4.5;
    doc.text("Receiver Name:", startX + 2, startY + textOffset);
    doc.text("Phone:", startX + 2, startY + rowHeight + textOffset);
    doc.text("Signature:", startX + 2, startY + rowHeight * 2 + textOffset);

    // Seal - centered on page
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20; // Reduced size from 25 to 20
      // Right block text is right-aligned at (pageWidth - 15). 
      // Subtracting 35 centers a 20px image comfortably above that alignment space.
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    const rightSectionStartY = startY + 4;
    const extraMargin = 6;

    doc.text(
      "Prepared by: __________________",
      rightAlignX,
      rightSectionStartY,
      { align: "right" },
    );
    doc.text(
      "Verified by: __________________",
      rightAlignX,
      rightSectionStartY + rowHeight,
      { align: "right" },
    );

    doc.setFont(undefined, "bold");
    doc.text(
      `For ${COMPANY_NAME}`,
      rightAlignX,
      rightSectionStartY + rowHeight * 2 + extraMargin,
      { align: "right" },
    );

    doc.setFontSize(7);
  } else {
    // Non-delivery order: seal centered above the signature line
    if (REPORT_SEAL_IMAGE) {
      const sealSize = 20;
      const sealX = (pageWidth - 15) - 35;
      const sealY = sigY - sealSize - 2;
      doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
    }

    doc.setFont(undefined, "bold");
    doc.text(config.footerLeft || "PREPARED BY", 15, sigY);
    doc.text("AUTHORIZED BY", pageWidth / 2, sigY, { align: "center" });
    doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, sigY, { align: "right" });
  }

  // ==== Page numbering ====
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setFont(undefined, "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, {
      align: "center",
    });
  }
};
const SaudiSalesReturnTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  includeCode = true,
  VATPERCENTAGE,
  VATMODE,
  qrCodeImage = null,
) => {
  if (!data || data.length === 0) return;

  if (AmiriRegular) {
    doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
    doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
  }

  const firstItem = data[0];
  const margin = 10;
  const contentWidth = pageWidth - 2 * margin;
  let yPosition = margin;

  const isVatApplied = firstItem.deliv_site === "VAT Applied";
  const vatPercent = isVatApplied ? Number(VATPERCENTAGE || 0) : 0;
  const vatRate = vatPercent / 100;

  const companyTRN =
    CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "-";

  const drawHeader = () => {
    const headerHeight = 35;
    if (REPORT_HEADER_IMAGE) {
      try {
        doc.addImage(REPORT_HEADER_IMAGE, "PNG", margin, margin, contentWidth, headerHeight);
      } catch (e) {
        console.warn("Could not add header image", e);
      }
    }
    return margin + headerHeight + 5;
  };

  yPosition = drawHeader();

  const titleBoxHeight = 15;
  doc.rect(margin, yPosition, contentWidth, titleBoxHeight);

  if (AmiriRegular) {
    doc.setFont("Amiri", "normal");
  } else {
    doc.setFont("helvetica", "bold");
  }
  doc.setFontSize(14);
  doc.text("TAX CREDIT NOTE - إشعار دائني ضريبي", margin + 5, yPosition + 10);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(`VAT NO : ${companyTRN}`, pageWidth - margin - 5, yPosition + 10, { align: "right" });

  yPosition += titleBoxHeight;

  const gridHeight = 42;
  const cellHeightRight = 14;
  const cellHeightLeft = 7;

  doc.setDrawColor(0);
  doc.rect(margin, yPosition, contentWidth, gridHeight);
  doc.line(pageWidth / 2, yPosition, pageWidth / 2, yPosition + gridHeight);

  const drawGridCell = (x, y, w, h, labelEn, labelAr, value) => {
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.text(labelEn, x + 2, y + h / 2 + 1.5, { baseline: "middle" });

    doc.setFont("Amiri", "normal");
    doc.text(labelAr, x + w - 2, y + h / 2 + 1.5, { align: "right", baseline: "middle" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    const valWidth = w - 40;
    const splitValue = doc.splitTextToSize(String(value || ""), valWidth);
    doc.text(splitValue, x + w / 2, y + h / 2 + 1, { align: "center", baseline: "middle" });

    if (y + h < yPosition + gridHeight) {
      doc.line(x, y + h, x + w, y + h);
    }
  };

  const colW = contentWidth / 2;

  const srDate = firstItem.sr_date
    ? new Date(firstItem.sr_date).toLocaleDateString("en-GB")
    : firstItem.inv_date
      ? new Date(firstItem.inv_date).toLocaleDateString("en-GB")
      : "-";

  const leftLabels = [
    ["SR NO", "رقم إشعار الدائن", firstItem.sr_no || firstItem.inv_no || "-"],
    ["DATE", "تاريخ الفاتورة", srDate],
    ["INV NO", "رقم الفاتورة الأصلية", firstItem.sr_inv_no || "-"],
    ["SALESMAN", "رجل المبيعات", firstItem.sale_man || "-"],
    ["REASON", "سبب الإرجاع", firstItem.Reason_of_Return || "-"],
    ["CONDITION", "حالة الصنف والتغليف", firstItem.Condition_of_Part || "-"],
  ];

  leftLabels.forEach((item, i) => {
    drawGridCell(margin, yPosition + i * cellHeightLeft, colW, cellHeightLeft, item[0], item[1], item[2], true);
  });

  const rightX = pageWidth / 2;

  drawGridCell(rightX, yPosition, colW, cellHeightRight, "CUSTOMER", "عميل", firstItem.custref || firstItem.tr_desc || "-", true);
  drawGridCell(rightX, yPosition + cellHeightRight, colW, cellHeightRight, "CITY", "عنوان", firstItem.address1 || "-", true);
  drawGridCell(rightX, yPosition + cellHeightRight * 2, colW, cellHeightRight, "TRN", "الرقم الضريبي", firstItem.governor || "-", true);

  yPosition += gridHeight + 5;

  const printableData = data.filter((item) => item.unit !== "FOC");

  autoTable(doc, {
    startY: yPosition,
    margin: { left: margin, right: margin },
    tableWidth: contentWidth,
    head: [
      [
        "S.NO\nرقم",
        "ITEM CODE\nرقم الصنف",
        "PRODUCT DESCRIPTION\nوصف المنتج",
        "UNIT\nالوحدة",
        "QTY\nالكمية",
        "PRICE SAR\nسعر",
        "AMOUNT SAR\nمبلغ",
        "VAT\nالضريبة",
      ],
    ],
    body: printableData.map((item, i) => {
      const qty = item.tr_qty || 0;
      const unitPrice = item.unit?.toUpperCase() === "FOC" ? 0 : (item.unit_price ?? item.unit_ppric ?? item.funit_pric ?? 0);
      const lineTotal = qty * unitPrice;
      const lineVat = isVatApplied ? Math.round(lineTotal * vatPercent) / 100 : 0;
      const lineTotalWithVat = lineTotal + lineVat;
      return [
        i + 1,
        item.code || "",
        item.idesc || item.tr_desc || "",
        item.unit || "NOS",
        qty,
        unitPrice.toFixed(2),
        lineTotalWithVat.toFixed(2),
        isVatApplied ? `${vatPercent.toFixed(0)}%` : "-",
      ];
    }),
    theme: "grid",
    styles: {
      font: "Amiri",
      fontSize: 7,
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      font: "Amiri",
      fontStyle: "normal",
      fontSize: 7,
    },
    columnStyles: {
      0: { cellWidth: 12, font: "helvetica" },
      1: { cellWidth: 25, font: "helvetica" },
      2: { cellWidth: "auto", halign: "left" },
      3: { cellWidth: 15 },
      4: { cellWidth: 15, font: "helvetica" },
      5: { cellWidth: 22, font: "helvetica" },
      6: { cellWidth: 22, font: "helvetica" },
      7: { cellWidth: 15, font: "helvetica" },
    },
    didParseCell: (data) => {
      if (data.section === "head" || /[\u0600-\u06FF]/.test(data.cell.text)) {
        data.cell.styles.font = "Amiri";
      } else if (data.section === "body") {
        data.cell.styles.font = "helvetica";
      }
    },
  });

  yPosition = doc.lastAutoTable.finalY + 5;

  const summaryHeight = 80;
  if (yPosition + summaryHeight > pageHeight - 40) {
    doc.addPage();
    yPosition = drawHeader();
  }

  const discountAmount = parseFloat(firstItem.disc_amt || 0);
  const subtotal = printableData.reduce((acc, item) => {
    const qty = item.tr_qty || 0;
    const unitPrice = item.unit?.toUpperCase() === "FOC" ? 0 : (item.unit_price ?? item.unit_ppric ?? item.funit_pric ?? 0);
    return acc + qty * unitPrice;
  }, 0);

  const taxableAmount = subtotal - discountAmount;
  const vatAmount = isVatApplied ? taxableAmount * vatRate : 0;
  const grandTotal = taxableAmount + vatAmount;
  const currency = firstItem.fc || "SAR";

  autoTable(doc, {
    startY: yPosition,
    margin: { left: margin, right: margin },
    tableWidth: contentWidth,
    body: [
      ["Subtotal", `${subtotal.toFixed(2)} ${currency}`, "الإجمالي الفرعي"],
      ["Discount", `${discountAmount.toFixed(2)} ${currency}`, "الخصم"],
      [`VAT ${vatPercent}%`, `${vatAmount.toFixed(2)} ${currency}`, "قيمة الضريبة"],
      ["Grand Total", `${grandTotal.toFixed(2)} ${currency}`, "المجموع الكلي"],
    ],
    theme: "grid",
    styles: {
      font: "helvetica",
      fontSize: 8,
      cellPadding: 2,
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
    },
    columnStyles: {
      0: { fillColor: [240, 240, 240], fontStyle: "bold", halign: "left", cellWidth: 50 },
      1: { halign: "center", fontStyle: "bold" },
      2: { fillColor: [240, 240, 240], font: "Amiri", halign: "right", cellWidth: 50 },
    },
  });

  yPosition = doc.lastAutoTable.finalY + 8;

  const textWidth = contentWidth - 45;
  const qrSize = 30;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const amountWords = `Amount Chargeable (in words): ${convertAmountToWords(grandTotal, firstItem.fc || "SAR").toUpperCase()}`;
  const splitWords = doc.splitTextToSize(amountWords, textWidth);
  doc.text(splitWords, margin, yPosition);

  const bankY = yPosition + splitWords.length * 4 + 2;
  doc.setFont("helvetica", "normal");
  doc.text("Bank Name : ALRAJHI BANK", margin, bankY);
  doc.text("IBAN : SA5780000458608015855007", margin, bankY + 5);
  doc.text("Account Number : 458000010006085855007", margin, bankY + 10);

  if (qrCodeImage) {
    try {
      doc.addImage(qrCodeImage, "PNG", pageWidth - margin - qrSize, yPosition - 2, qrSize, qrSize);
    } catch (e) {
      console.warn("Could not add QR code image", e);
    }
  }

  const footerTop = pageHeight - 35;
  const sigY = footerTop - 15;

  doc.line(margin, sigY, margin + 50, sigY);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Received By", margin + 25, sigY + 5, { align: "center" });

  const authSignX = pageWidth - margin - 60;
  doc.line(authSignX, sigY, pageWidth - margin, sigY);
  doc.setFont("helvetica", "bold");
  doc.text(`For ${COMPANY_NAME}`, authSignX + 30, sigY + 5, { align: "center" });

  if (REPORT_FOOTER_IMAGE) {
    try {
      doc.addImage(REPORT_FOOTER_IMAGE, "PNG", margin, footerTop, contentWidth, 20);
    } catch (e) {
      console.warn("Could not add footer image", e);
    }
  }
};

const SalesReturnTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  includeCode = true,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  // Draw header
  const headerHeight = drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE);
  let yPosition = headerHeight + 4;

  // ==== Modern Title Section ====
  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(config.title, pageWidth / 2, yPosition, { align: "center" });

  yPosition += 7;

  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const companyTRN =
    CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "-";
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.setTextColor(80, 80, 80);
  doc.text(`TRN NO : ${companyTRN}`, pageWidth / 2, yPosition, { align: "center" });

  yPosition += 6;

  // ==== Clean Info Cards Layout ====
  const margin = 15;
  const cardGap = 3;
  const contentWidth = pageWidth - 2 * margin;
  const customerCardWidth = contentWidth * 0.68;
  const docCardWidth = contentWidth * 0.32 - cardGap;
  const cardHeight = 30;
  const topMargin = 45;
  const bottomMargin = 35;

  // Customer Info Card - Clean white with subtle border
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.roundedRect(margin, yPosition, customerCardWidth, cardHeight, 2, 2);

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("CUSTOMER DETAILS", margin + 3, yPosition + 5);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(
    firstItem.tr_desc || firstItem.custref || "",
    margin + 3,
    yPosition + 11,
  );

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(80, 80, 80);
  doc.text(`Tel: ${firstItem.tel || "-"}`, margin + 3, yPosition + 17);
  doc.text(`TRN: ${firstItem.governor || ""}`, margin + 3, yPosition + 23);

  // Document Details Card - Minimal design
  const docCardX = margin + customerCardWidth + cardGap;
  doc.roundedRect(docCardX, yPosition, docCardWidth, cardHeight, 2, 2);

  const labelX = docCardX + 3;
  const valueX = docCardX + docCardWidth - 3;
  let detailY = yPosition + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);

  // SR Number
  doc.text(config.numberLabel, labelX, detailY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(firstItem[config.numberField]?.toString() || "", valueX, detailY, {
    align: "right",
  });

  detailY += 6;
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(config.dateLabel, labelX, detailY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  const docDate = firstItem[config.dateField]
    ? new Date(firstItem[config.dateField]).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailY, { align: "right" });

  // Dynamic detail fields
  config.detailFields.forEach((field) => {
    detailY += 6;
    doc.setFont(undefined, "normal");
    doc.setTextColor(100, 100, 100);
    doc.text(field.label, labelX, detailY);
    doc.setFont(undefined, "bold");
    doc.setTextColor(30, 30, 30);
    const fieldValue = firstItem[field.field]?.toString() || "-";
    // Truncate if too long
    const maxWidth = docCardWidth - 6;
    const truncated = doc.splitTextToSize(fieldValue, maxWidth)[0];
    doc.text(truncated, valueX, detailY, { align: "right" });
  });

  yPosition += cardHeight + 3;

  // ==== Return Reason Section (Minimal Header Style with Red Label) ====
  if (firstItem.Reason_of_Return || firstItem.Condition_of_Part) {
    const sectionHeight = 8;
    const sectionY = yPosition;

    // Subtle light-gray divider line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.2);
    doc.line(
      margin,
      sectionY + sectionHeight + 1,
      margin + contentWidth,
      sectionY + sectionHeight + 1,
    );

    doc.setFontSize(8.5);
    doc.setFont(undefined, "bold");
    doc.setTextColor(200, 30, 30); // deep red
    doc.text("RETURN REASON:", margin, sectionY + 6);

    const returnInfo = `${(
      firstItem.Reason_of_Return || ""
    ).toUpperCase()} - ${(firstItem.Condition_of_Part || "").toUpperCase()}`;
    doc.setFont(undefined, "normal");
    doc.setTextColor(80, 80, 80);
    doc.text(returnInfo, margin + 35, sectionY + 6);

    yPosition += sectionHeight + 4;
  }

  // ==== Table Section ====
  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = includeCode
    ? config.columns.withCode
    : config.columns.withoutCode;
  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = generateTableRows(data, config, includeCode, VATPERCENTAGE);

  const tableStartY = yPosition;
  const usableHeight =
    pageHeight - bottomMargin - tableStartY - (config.showPricing ? 80 : 60);
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (usableHeight - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [3, 135, 189],
      textColor: [250, 250, 250],
    },
    columnStyles,
    margin: {
      left: leftMargin,
      right: rightMargin,
      top: topMargin,
      bottom: bottomMargin,
    },
    tableWidth: includeCode ? "auto" : usableWidth,
    didDrawCell: function (data) {
      const { cell, table } = data;
      const { x, y, width, height } = cell;

      doc.setDrawColor(0);
      doc.setLineWidth(0.1);

      if (cell.x === table.body[0]?.cells?.[0]?.x) {
        doc.line(x, y, x, y + height);
      }

      doc.line(x + width, y, x + width, y + height);

      if (data.section === "head") {
        doc.line(x, y, x + width, y);
      }

      if (data.section === "body" && data.row.index === table.body.length - 1) {
        doc.line(x, y + height, x + width, y + height);
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 6;

  // ==== Calculations ====
  const grossAmount = data.reduce((sum, item) => {
    const qty = item.tr_qty || 0;
    const unitPrice =
      item.unit?.toUpperCase() === "FOC"
        ? 0
        : (item.unit_ppric ?? item.unit_price ?? 0);
    return sum + qty * unitPrice;
  }, 0);

  const discount = firstItem.disc_amt || 0;
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.deliv_site === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = vatRate > 0 ? taxableAmount * (vatRate / 100) : 0;
  const grandTotal = taxableAmount + vatAmount;

  // ==== Modern Totals Section ====
  const boxMargin = 15;
  const boxWidth = pageWidth - 2 * boxMargin;
  const boxHeight = 32;
  const boxStartY = currentY;

  // Clean border
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.roundedRect(boxMargin, boxStartY, boxWidth, boxHeight, 2, 2);

  // Left section - Amount in Words
  const leftX = boxMargin + 3;
  const leftMaxWidth = pageWidth / 2 - boxMargin - 8;
  let leftY = boxStartY + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("AMOUNT IN WORDS:", leftX, leftY);
  leftY += 5;
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(30, 30, 30);
  const amountInWords = convertAmountToWords(grandTotal, firstItem.fc || "AED");
  const amountLines = doc.splitTextToSize(amountInWords, leftMaxWidth);
  doc.text(amountLines, leftX, leftY);
  leftY += amountLines.length * 4;

  leftY += 2;
  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.setTextColor(120, 120, 120);
  doc.text(`Payment: ${firstItem.payment || "N/A"}`, leftX, leftY);

  // Right section - Totals with modern styling
  const rightLabelX = pageWidth / 2 + 8;
  const rightValueX = pageWidth - boxMargin - 3;
  let rightY = boxStartY + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);

  // Gross Amount
  doc.text("Gross Amount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  // Discount
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Discount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  // Taxable Amount
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Taxable Amount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  // VAT
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(`VAT (${vatRate}%)`, rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });

  // Subtle line before total
  rightY += 1;
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(rightLabelX, rightY, rightValueX, rightY);
  rightY += 4;

  // Grand Total
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text("Total Incl. VAT", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  currentY = boxStartY + boxHeight + 10;

  // ==== Clean Footer Section ====
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("REMARKS:", 15, currentY);
  doc.setFont(undefined, "normal");
  doc.setFontSize(7);
  doc.setTextColor(80, 80, 80);
  const remarks =
    firstItem.comments ||
    "Please inspect returned items immediately upon receipt.";
  doc.text(remarks, 15, currentY + 4);

  currentY += 14;

  // Signature section - Minimal design
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(60, 60, 60);
  doc.text(config.footerLeft, 15, currentY);
  doc.text("APPROVED BY", pageWidth / 2, currentY, { align: "center" });
  doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, currentY, { align: "right" });

  // Clean signature lines
  currentY += 12;
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(15, currentY, 55, currentY);
  doc.line(pageWidth / 2 - 20, currentY, pageWidth / 2 + 20, currentY);
  doc.line(pageWidth - 55, currentY, pageWidth - 15, currentY);

  // Date labels under signature lines
  doc.setFontSize(6);
  doc.setFont(undefined, "normal");
  doc.setTextColor(120, 120, 120);
  doc.text("Date: ___________", 15, currentY + 4);
  doc.text("Date: ___________", pageWidth / 2 - 20, currentY + 4);
  doc.text("Date: ___________", pageWidth - 55, currentY + 4);

  // Draw footer on all pages
  const pageCount = doc.internal.getNumberOfPages();
  const FOOTER_HEIGHT = 30;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    doc.setFontSize(7);
    doc.setFont(undefined, "normal");
    doc.setTextColor(150, 150, 150);

    const pageNumberY = pageHeight - FOOTER_HEIGHT - 2;
    doc.text(`Page ${i} of ${pageCount}`, pageWidth - 15, pageNumberY, {
      align: "right",
    });

    drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
  }
};

const PurchaseReturnTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  config,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  includeCode = true,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const headerHeight = drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE);
  let yPosition = headerHeight + 4;

  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(config.title, pageWidth / 2, yPosition, { align: "center" });

  yPosition += 7;

  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const companyTRN =
    CURRENT_USER_OBJECT[0]?.trn || CURRENT_USER_OBJECT[0]?.TRN || "-";
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.setTextColor(80, 80, 80);
  doc.text(`TRN NO : ${companyTRN}`, pageWidth / 2, yPosition, { align: "center" });

  yPosition += 6;

  const margin = 15;
  const cardGap = 3;
  const contentWidth = pageWidth - 2 * margin;
  const supplierCardWidth = contentWidth * 0.68;
  const docCardWidth = contentWidth * 0.32 - cardGap;
  const cardHeight = 30;
  const topMargin = 45;
  const bottomMargin = 35;

  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.roundedRect(margin, yPosition, supplierCardWidth, cardHeight, 2, 2);

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("SUPPLIER DETAILS", margin + 3, yPosition + 5);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(
    firstItem.tr_desc || firstItem.custref || "",
    margin + 3,
    yPosition + 11,
  );

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(80, 80, 80);
  doc.text(`Account: ${firstItem.cust_acc || "-"}`, margin + 3, yPosition + 17);
  doc.text(`TRN: ${firstItem.CCNO || firstItem.governor || ""}`, margin + 3, yPosition + 23);

  const docCardX = margin + supplierCardWidth + cardGap;
  doc.roundedRect(docCardX, yPosition, docCardWidth, cardHeight, 2, 2);

  const labelX = docCardX + 3;
  const valueX = docCardX + docCardWidth - 3;
  let detailY = yPosition + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);

  doc.text(config.numberLabel, labelX, detailY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(firstItem[config.numberField]?.toString() || "", valueX, detailY, {
    align: "right",
  });

  detailY += 6;
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(config.dateLabel, labelX, detailY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  const docDate = firstItem[config.dateField]
    ? new Date(firstItem[config.dateField]).toLocaleDateString("en-GB")
    : "";
  doc.text(docDate, valueX, detailY, { align: "right" });

  config.detailFields.forEach((field) => {
    detailY += 6;
    doc.setFont(undefined, "normal");
    doc.setTextColor(100, 100, 100);
    doc.text(field.label, labelX, detailY);
    doc.setFont(undefined, "bold");
    doc.setTextColor(30, 30, 30);
    const fieldValue = firstItem[field.field]?.toString() || "-";
    const maxWidth = docCardWidth - 6;
    const truncated = doc.splitTextToSize(fieldValue, maxWidth)[0];
    doc.text(truncated, valueX, detailY, { align: "right" });
  });

  yPosition += cardHeight + 3;

  if (firstItem.Reason_of_Return || firstItem.Condition_of_Part) {
    const sectionHeight = 8;
    const sectionY = yPosition;

    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.2);
    doc.line(
      margin,
      sectionY + sectionHeight + 1,
      margin + contentWidth,
      sectionY + sectionHeight + 1,
    );

    doc.setFontSize(8.5);
    doc.setFont(undefined, "bold");
    doc.setTextColor(200, 30, 30);
    doc.text("RETURN REASON:", margin, sectionY + 6);

    const returnInfo = `${(
      firstItem.Reason_of_Return || ""
    ).toUpperCase()} - ${(firstItem.Condition_of_Part || "").toUpperCase()}`;
    doc.setFont(undefined, "normal");
    doc.setTextColor(80, 80, 80);
    doc.text(returnInfo, margin + 35, sectionY + 6);

    yPosition += sectionHeight + 4;
  }

  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = includeCode
    ? config.columns.withCode
    : config.columns.withoutCode;
  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = generateTableRows(data, config, includeCode, VATPERCENTAGE);

  const tableStartY = yPosition;
  const usableHeight =
    pageHeight - bottomMargin - tableStartY - (config.showPricing ? 80 : 60);
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (usableHeight - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
      lineWidth: 0,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [3, 135, 189],
      textColor: [250, 250, 250],
    },
    columnStyles,
    margin: {
      left: leftMargin,
      right: rightMargin,
      top: topMargin,
      bottom: bottomMargin,
    },
    tableWidth: includeCode ? "auto" : usableWidth,
    didDrawCell: function (data) {
      const { cell, table } = data;
      const { x, y, width, height } = cell;

      doc.setDrawColor(0);
      doc.setLineWidth(0.1);

      if (cell.x === table.body[0]?.cells?.[0]?.x) {
        doc.line(x, y, x, y + height);
      }

      doc.line(x + width, y, x + width, y + height);

      if (data.section === "head") {
        doc.line(x, y, x + width, y);
      }

      if (data.section === "body" && data.row.index === table.body.length - 1) {
        doc.line(x, y + height, x + width, y + height);
      }
    },
  });

  let currentY = doc.lastAutoTable.finalY + 6;

  const grossAmount = data.reduce((sum, item) => {
    const qty = item.tr_qty || 0;
    const unitPrice =
      item.unit?.toUpperCase() === "FOC"
        ? 0
        : (item.unit_price ?? item.unit_cost ?? 0);
    return sum + qty * unitPrice;
  }, 0);

  const discount = Number(firstItem.disc_amt || 0);
  const taxableAmount = grossAmount - discount;
  const vatRate = firstItem.client_pd === "VAT Applied" ? VATPERCENTAGE : 0;
  const vatAmount = vatRate > 0 ? taxableAmount * (vatRate / 100) : 0;
  const grandTotal = taxableAmount + vatAmount;

  const boxMargin = 15;
  const boxWidth = pageWidth - 2 * boxMargin;
  const boxHeight = 32;
  const boxStartY = currentY;

  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.roundedRect(boxMargin, boxStartY, boxWidth, boxHeight, 2, 2);

  const leftX = boxMargin + 3;
  const leftMaxWidth = pageWidth / 2 - boxMargin - 8;
  let leftY = boxStartY + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("AMOUNT IN WORDS:", leftX, leftY);
  leftY += 5;
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(30, 30, 30);
  const amountInWords = convertAmountToWords(grandTotal, firstItem.fc || "AED");
  const amountLines = doc.splitTextToSize(amountInWords, leftMaxWidth);
  doc.text(amountLines, leftX, leftY);
  leftY += amountLines.length * 4;

  leftY += 2;
  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.setTextColor(120, 120, 120);
  doc.text(`Payment: ${firstItem.payment || "N/A"}`, leftX, leftY);

  const rightLabelX = pageWidth / 2 + 8;
  const rightValueX = pageWidth - boxMargin - 3;
  let rightY = boxStartY + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);

  doc.text("Gross Amount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(grossAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Discount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(discount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text("Taxable Amount", rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(taxableAmount.toFixed(2), rightValueX, rightY, { align: "right" });
  rightY += 5;

  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(`VAT (${vatRate}%)`, rightLabelX, rightY);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text(vatAmount.toFixed(2), rightValueX, rightY, { align: "right" });

  rightY += 1;
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(rightLabelX, rightY, rightValueX, rightY);
  rightY += 4;

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 30, 30);
  doc.text("Total Incl. VAT", rightLabelX, rightY);
  doc.text(grandTotal.toFixed(2), rightValueX, rightY, { align: "right" });

  currentY = boxStartY + boxHeight + 10;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 100, 100);
  doc.text("REMARKS:", 15, currentY);
  doc.setFont(undefined, "normal");
  doc.setFontSize(7);
  doc.setTextColor(80, 80, 80);
  const remarks =
    firstItem.comments ||
    "Please inspect returned items immediately upon receipt.";
  doc.text(remarks, 15, currentY + 4);

  currentY += 14;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(60, 60, 60);
  doc.text(config.footerLeft, 15, currentY);
  doc.text("APPROVED BY", pageWidth / 2, currentY, { align: "center" });
  doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, currentY, { align: "right" });

  currentY += 12;
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(15, currentY, 55, currentY);
  doc.line(pageWidth / 2 - 20, currentY, pageWidth / 2 + 20, currentY);
  doc.line(pageWidth - 55, currentY, pageWidth - 15, currentY);

  doc.setFontSize(6);
  doc.setFont(undefined, "normal");
  doc.setTextColor(120, 120, 120);
  doc.text("Date: ___________", 15, currentY + 4);
  doc.text("Date: ___________", pageWidth / 2 - 20, currentY + 4);
  doc.text("Date: ___________", pageWidth - 55, currentY + 4);

  const pageCount = doc.internal.getNumberOfPages();
  const FOOTER_HEIGHT = 30;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    doc.setFontSize(7);
    doc.setFont(undefined, "normal");
    doc.setTextColor(150, 150, 150);

    const pageNumberY = pageHeight - FOOTER_HEIGHT - 2;
    doc.text(`Page ${i} of ${pageCount}`, pageWidth - 15, pageNumberY, {
      align: "right",
    });

    drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
  }
};
const SampleIssueTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  // Draw header
  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  // ==== Title ====
  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("SAMPLE ISSUE", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  // ==== Info Boxes Layout ====
  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const customerBoxWidth = contentWidth * 0.7;
  const docBoxWidth = contentWidth * 0.3 - boxGap;

  // --- Calculate dynamic height for Document Details Box based on Project string length
  const labelX = margin + customerBoxWidth + boxGap + 2;
  const valueX = margin + customerBoxWidth + boxGap + 22;
  const maxProjectTextWidth = docBoxWidth - 24; // Width available for project value string

  let wrappedProjectLines = [];
  if (firstItem?.insurance) {
    doc.setFontSize(9);
    wrappedProjectLines = doc.splitTextToSize(firstItem.insurance.toString(), maxProjectTextWidth);
  }

  // Standard lines take ~18 units. Each extra wrapped line adds roughly 5-6 units.
  const dynamicDocBoxHeight = 18 + (wrappedProjectLines.length > 0 ? 6 * wrappedProjectLines.length : 0);
  const boxHeight = Math.max(28, dynamicDocBoxHeight);

  // --- Customer Info Box (70%)
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.rect(margin, yPosition, customerBoxWidth, boxHeight);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.tr_desc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);

  doc.text(`ACCOUNT : ${firstItem.cust_acc || "-"}`, margin + 2, yPosition + 15);
  doc.text(`NAME : ${firstItem.DrAccDesc || "-"}`, margin + 2, yPosition + 21);
  doc.text(`Tel : ${firstItem.tel || "-"}`, margin + 2, yPosition + 27);

  // --- Document Details Box (30%)
  const detailsX = margin + customerBoxWidth + boxGap;
  doc.rect(detailsX, yPosition, docBoxWidth, boxHeight);

  let detailsY = yPosition + 6;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text("ISSUE NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.inv_no || "",
    valueX,
    detailsY,
  );

  detailsY += 6;
  doc.setFont(undefined, "normal");
  doc.text("ISSUE DATE:", labelX, detailsY);
  const issueDate =
    firstItem.do_date || firstItem.inv_date
      ? new Date(firstItem.do_date || firstItem.inv_date).toLocaleDateString("en-GB")
      : "";
  doc.text(issueDate, valueX, detailsY);

  detailsY += 6;
  doc.text("REF NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.lpo_no?.toString() || "-", valueX, detailsY);

  if (wrappedProjectLines.length > 0) {
    detailsY += 6;
    doc.setFont(undefined, "normal");
    doc.text("PROJECT:", labelX, detailsY);
    doc.setFont(undefined, "bold");

    // Print wrapped lines down sequentially
    for (let i = 0; i < wrappedProjectLines.length; i++) {
      doc.text(wrappedProjectLines[i], valueX, detailsY);
      if (i < wrappedProjectLines.length - 1) detailsY += 5;
    }
  }

  yPosition += boxHeight + 10;

  // ==== Table Section ====
  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "SN", ratio: 0.05, align: "center" },
    { header: "CODE", ratio: 0.15, align: "center" },
    { header: "DESCRIPTION", ratio: 0.45, align: "left" },
    { header: "LOCN", ratio: 0.08, align: "center" },
    { header: "BATCH", ratio: 0.1, align: "center" },
    { header: "UNIT", ratio: 0.08, align: "center" },
    { header: "QTY", ratio: 0.09, align: "center" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];

  const tableBody = data.map((item, index) => {
    const qty = Number(item.tr_qty || item.tr_qty2 || 0);
    return [
      (index + 1).toString(),
      item.code || "",
      item.idesc || "",
      item.locn || "",
      item.batch || "",
      item.unit || "PCS",
      qty.toFixed(2),
    ];
  });

  const signatureSectionHeight = 45;
  const footerImageHeight = 30;
  const bottomMarginSpace = footerImageHeight + signatureSectionHeight;

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: yPosition,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [3, 135, 189],
      textColor: [250, 250, 250],
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin, bottom: bottomMarginSpace },
    tableWidth: usableWidth,
  });

  let signatureY = pageHeight - footerImageHeight - 20;

  if (doc.lastAutoTable.finalY >= signatureY - 10) {
    doc.addPage();
    signatureY = pageHeight - footerImageHeight - 20;
  }

  doc.setFont(undefined, "bold");
  doc.setFontSize(9);

  if (REPORT_SEAL_IMAGE) {
    const sealSize = 20;
    const sealX = (pageWidth - 15) - 35;
    const sealY = signatureY - sealSize - 2;
    doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
  }

  doc.text("ISSUED BY", 15, signatureY);

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(firstItem.sale_man || "", 15, signatureY + 6);

  doc.setFont(undefined, "bold");
  doc.setFontSize(9);
  doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, signatureY, {
    align: "right",
  });

  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};

// Sample Return Template
const SampleReturnTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  // Draw header
  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  // ==== Title ====
  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("SAMPLE RETURN", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  // ==== Info Boxes Layout ====
  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const customerBoxWidth = contentWidth * 0.7;
  const docBoxWidth = contentWidth * 0.3 - boxGap;

  // --- Calculate dynamic height for Document Details Box based on Project string length
  const labelX = margin + customerBoxWidth + boxGap + 2;
  const valueX = margin + customerBoxWidth + boxGap + 22;
  const maxProjectTextWidth = docBoxWidth - 24;

  let wrappedProjectLines = [];
  if (firstItem?.insurance) {
    doc.setFontSize(9);
    wrappedProjectLines = doc.splitTextToSize(firstItem.insurance.toString(), maxProjectTextWidth);
  }

  const dynamicDocBoxHeight = 18 + (wrappedProjectLines.length > 0 ? 6 * wrappedProjectLines.length : 0);
  const boxHeight = Math.max(28, dynamicDocBoxHeight);

  // --- Customer Info Box (70%)
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.rect(margin, yPosition, customerBoxWidth, boxHeight);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.tr_desc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(`Tel: ${firstItem.tel || "-"}`, margin + 2, yPosition + 14);
  doc.text(`TRN: ${firstItem.governor || ""}`, margin + 2, yPosition + 20);

  // --- Document Details Box (30%)
  const detailsX = margin + customerBoxWidth + boxGap;
  doc.rect(detailsX, yPosition, docBoxWidth, boxHeight);

  let detailsY = yPosition + 6;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text("RETURN NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.do_no?.toString() || firstItem.inv_no || "",
    valueX,
    detailsY,
  );

  detailsY += 6;
  doc.setFont(undefined, "normal");
  doc.text("RET DATE:", labelX, detailsY);
  const returnDate =
    firstItem.do_date || firstItem.inv_date
      ? new Date(firstItem.do_date || firstItem.inv_date).toLocaleDateString("en-GB")
      : "";
  doc.text(returnDate, valueX, detailsY);

  detailsY += 6;
  doc.text("ISSUE NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.lpo_no?.toString() || "-", valueX, detailsY);

  if (wrappedProjectLines.length > 0) {
    detailsY += 6;
    doc.setFont(undefined, "normal");
    doc.text("PROJECT:", labelX, detailsY);
    doc.setFont(undefined, "bold");

    // Print wrapped lines down sequentially
    for (let i = 0; i < wrappedProjectLines.length; i++) {
      doc.text(wrappedProjectLines[i], valueX, detailsY);
      if (i < wrappedProjectLines.length - 1) detailsY += 5;
    }
  }

  yPosition += boxHeight + 10;

  // ==== Table Section ====
  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "SN", ratio: 0.05, align: "center" },
    { header: "CODE", ratio: 0.15, align: "center" },
    { header: "DESCRIPTION", ratio: 0.45, align: "left" },
    { header: "LOCN", ratio: 0.08, align: "center" },
    { header: "BATCH", ratio: 0.1, align: "center" },
    { header: "UNIT", ratio: 0.08, align: "center" },
    { header: "QTY", ratio: 0.09, align: "center" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];

  const tableBody = data.map((item, index) => {
    const qty = Number(item.tr_qty || item.tr_qty2 || 0);

    return [
      (index + 1).toString(),
      item.code || "",
      item.idesc || "",
      item.locn || "",
      item.batch || "",
      item.unit || "PCS",
      qty.toFixed(2),
    ];
  });

  const tableStartY = yPosition;
  const footerHeight = 30;
  const spaceForTable = pageHeight - footerHeight - 100;
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (spaceForTable - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [3, 135, 189],
      textColor: [250, 250, 250],
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin },
    tableWidth: usableWidth,
  });

  let currentY = doc.lastAutoTable.finalY + 10;

  // ==== Remarks Section ====
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("REMARKS:", 15, currentY);
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(
    firstItem.comments || "Sample items returned after evaluation",
    15,
    currentY + 5,
  );
  currentY += 15;

  // ==== Footer Section (Signature area) ====
  doc.setFont(undefined, "bold");

  if (REPORT_SEAL_IMAGE) {
    const sealSize = 20;
    const sealX = (pageWidth - 15) - 35;
    const sealY = currentY - sealSize - 2;
    doc.addImage(REPORT_SEAL_IMAGE, "PNG", sealX, sealY, sealSize, sealSize);
  }

  doc.text("RETURNED BY", 15, currentY);
  doc.text(firstItem.sale_man || "", pageWidth / 2, currentY, {
    align: "center",
  });
  doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, currentY, {
    align: "right",
  });

  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};
//work order template
const WorkOrderTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  // Draw header
  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 10;

  // ==== Title ====
  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("WORK ORDER", pageWidth / 2, yPosition, { align: "center" });
  yPosition += 10;

  // ==== Info Boxes Layout ====
  const margin = 15;
  const boxGap = 2;
  const contentWidth = pageWidth - 2 * margin;
  const customerBoxWidth = contentWidth * 0.7;
  const docBoxWidth = contentWidth * 0.3 - boxGap;
  const boxHeight = 28;

  // --- Customer Info Box (70%)
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.rect(margin, yPosition, customerBoxWidth, boxHeight);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.custref || firstItem.accdesc || "",
    margin + 2,
    yPosition + 8,
  );

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(`Tel: ${firstItem.tel || "-"}`, margin + 2, yPosition + 14);
  doc.text(`TRN: ${firstItem.governor || ""}`, margin + 2, yPosition + 20);

  // --- Document Details Box (30%)
  const detailsX = margin + customerBoxWidth + boxGap;
  doc.rect(detailsX, yPosition, docBoxWidth, boxHeight);

  const labelX = detailsX + 2;
  const valueX = detailsX + 22;
  let detailsY = yPosition + 6;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text("ORDER NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(
    firstItem.so_no?.toString() || firstItem.inv_no || "",
    valueX,
    detailsY,
  );

  detailsY += 6;
  doc.setFont(undefined, "normal");
  doc.text("ORDER DATE:", labelX, detailsY);
  const orderDate =
    firstItem.so_date || firstItem.inv_date
      ? new Date(firstItem.so_date || firstItem.inv_date).toLocaleDateString(
        "en-GB",
      )
      : "";
  doc.text(orderDate, valueX, detailsY);

  detailsY += 6;
  doc.text("INVOICE NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.terms?.toString() || "-", valueX, detailsY);

  detailsY += 6;
  doc.setFont(undefined, "normal");
  doc.text("REF NO:", labelX, detailsY);
  doc.setFont(undefined, "bold");
  doc.text(firstItem.tr_refno?.toString() || "-", valueX, detailsY);

  yPosition += boxHeight + 10;

  // ==== Table Section ====
  const leftMargin = 15;
  const rightMargin = 15;
  const usableWidth = pageWidth - leftMargin - rightMargin;

  const columns = [
    { header: "SN", ratio: 0.05, align: "center" },
    { header: "CODE", ratio: 0.15, align: "center" },
    { header: "DESCRIPTION", ratio: 0.45, align: "left" },
    { header: "LOCN", ratio: 0.08, align: "center" },
    { header: "BATCH", ratio: 0.1, align: "center" },
    { header: "UNIT", ratio: 0.08, align: "center" },
    { header: "QTY", ratio: 0.09, align: "center" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: usableWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];

  // Generate table rows
  const tableBody = data.map((item, index) => {
    const qty = Number(item.so_qty || item.tr_qty2 || 0);

    return [
      (index + 1).toString(),
      item.so_icode || "",
      item.idesc || "",
      item.locn || "",
      item.batch || "",
      item.unit || "PCS",
      qty.toFixed(2),
    ];
  });

  const tableStartY = yPosition;
  const footerHeight = 30;
  const spaceForTable = pageHeight - footerHeight - 100;
  const estimatedRowHeight = 10;
  const currentTableHeight = tableBody.length * estimatedRowHeight;
  const remainingRows = Math.floor(
    (spaceForTable - currentTableHeight) / estimatedRowHeight,
  );

  for (let i = 0; i < remainingRows; i++) {
    tableBody.push(Array(columns.length).fill(""));
  }

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: tableStartY,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
      overflow: "linebreak",
      textColor: [0, 0, 0],
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [3, 135, 189],
      textColor: [250, 250, 250],
    },
    columnStyles,
    margin: { left: leftMargin, right: rightMargin },
    tableWidth: usableWidth,
  });

  let currentY = doc.lastAutoTable.finalY + 10;

  // ==== Remarks Section ====
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text("REMARKS:", 15, currentY);
  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.text(firstItem.comments, 15, currentY + 5);
  currentY += 15;

  // ==== Footer Section (Signature area) ====
  doc.setFont(undefined, "bold");
  doc.text("PREPARED BY", 15, currentY);
  doc.text(firstItem.sale_man || "", pageWidth / 2, currentY, {
    align: "center",
  });
  doc.text(`For ${COMPANY_NAME}`, pageWidth - 15, currentY, {
    align: "right",
  });

  // Draw footer on all pages
  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};
const generatePurchaseInvoicePDF = (
  doc,
  pageWidth,
  pageHeight,
  templateId,
  data,
  COMPANY_NAME,
  otherCosts = [],
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  VATPERCENTAGE,
  VATMODE,
) => {
  if (!data || data.length === 0) return;

  switch (templateId) {
    case "purchase_template1":
      // Standard Purchase Invoice (like Proforma)
      PurchaseInvoiceStandard(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
      );
      break;

    case "purchase_template2":
      // Purchase Invoice with Other Costs
      PurchaseInvoiceWithOtherCosts(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        otherCosts,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
      );
      break;

    default:
      // Default to standard template
      PurchaseInvoiceStandard(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
      );
  }
};

export {
  PurchaseInvoiceStandard,
  PurchaseInvoiceWithOtherCosts,
  generatePurchaseInvoicePDF,
};

const WarrantyClaimTemplate = (
  doc,
  pageWidth,
  pageHeight,
  data,
  COMPANY_NAME,
  REPORT_HEADER_IMAGE,
  REPORT_FOOTER_IMAGE,
) => {
  if (!data || data.length === 0) return;
  const firstItem = data[0];

  const margin = 15;
  const contentWidth = pageWidth - 2 * margin;

  const headerHeight = REPORT_HEADER_IMAGE
    ? drawHeader(doc, pageWidth, REPORT_HEADER_IMAGE)
    : 0;
  let yPosition = headerHeight + 8;

  // Modern Title Section
  doc.setFontSize(22);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 41, 59); // Slate 800
  doc.text("WARRANTY CLAIM", margin, yPosition);

  // Title separator line
  doc.setDrawColor(226, 232, 240); // Slate 200
  doc.setLineWidth(0.5);
  doc.line(margin, yPosition + 4, pageWidth - margin, yPosition + 4);

  yPosition += 10;

  const supplierBoxWidth = contentWidth * 0.55;
  const docBoxWidth = contentWidth * 0.4;
  const detailsX = pageWidth - margin - docBoxWidth;

  // Customer Details - Modern Light Background
  doc.setFillColor(248, 250, 252); // Slate 50
  if (typeof doc.roundedRect === "function") {
    doc.roundedRect(margin, yPosition, supplierBoxWidth, 26, 2, 2, "F");
  } else {
    doc.rect(margin, yPosition, supplierBoxWidth, 26, "F");
  }

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139); // Slate 500
  doc.text("CUSTOMER DETAILS", margin + 4, yPosition + 6);

  doc.setFontSize(11);
  doc.setFont(undefined, "bold");
  doc.setTextColor(30, 41, 59);
  doc.text(
    firstItem.Accdesc || firstItem.accdesc || "Customer Name",
    margin + 4,
    yPosition + 12,
  );

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.setTextColor(71, 85, 105); // Slate 600
  doc.text(
    `Account:  ${firstItem.Account || firstItem.account || "-"}`,
    margin + 4,
    yPosition + 18,
  );
  doc.text(
    `Contact:  ${firstItem.contactNo || firstItem.tel || "-"}`,
    margin + 4,
    yPosition + 23,
  );

  // Document Details - Modern Light Background
  doc.setFillColor(248, 250, 252); // Slate 50
  if (typeof doc.roundedRect === "function") {
    doc.roundedRect(detailsX, yPosition, docBoxWidth, 28, 2, 2, "F");
  } else {
    doc.rect(detailsX, yPosition, docBoxWidth, 28, "F");
  }

  const labelX = detailsX + 4;
  const valueX = detailsX + 28;
  let detailsY = yPosition + 6;

  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("CLAIM NO:", labelX, detailsY);
  doc.setTextColor(30, 41, 59);
  doc.text(firstItem.claimno?.toString() || "-", valueX, detailsY);

  detailsY += 6;
  doc.setTextColor(100, 116, 139);
  doc.text("DATE:", labelX, detailsY);
  doc.setTextColor(30, 41, 59);
  const docDate =
    firstItem.ClaimDate || firstItem.date
      ? new Date(firstItem.ClaimDate || firstItem.date).toLocaleDateString(
        "en-GB",
      )
      : "";
  doc.setFont(undefined, "normal");
  doc.text(docDate, valueX, detailsY);

  detailsY += 6;
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("INV NO:", labelX, detailsY);
  doc.setTextColor(30, 41, 59);
  doc.text(firstItem.InvoiceNo?.toString() || "-", valueX, detailsY);

  detailsY += 6;
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("INV DATE:", labelX, detailsY);
  doc.setTextColor(30, 41, 59);
  const invDateObj =
    firstItem.SalesDate || firstItem.inv_date
      ? new Date(firstItem.SalesDate || firstItem.inv_date).toLocaleDateString(
        "en-GB",
      )
      : "-";
  doc.setFont(undefined, "normal");
  doc.text(invDateObj, valueX, detailsY);

  yPosition += 36;

  if (firstItem.Remarks || firstItem.remarks) {
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.setTextColor(100, 116, 139);
    doc.text("Remarks:", margin, yPosition);
    doc.setFont(undefined, "normal");
    doc.setTextColor(71, 85, 105);
    doc.text(
      (firstItem.Remarks || firstItem.remarks).toString(),
      margin + 16,
      yPosition,
    );
    yPosition += 8;
  }

  yPosition += 2;

  const columns = [
    { header: "SN", ratio: 0.06, align: "center" },
    { header: "CODE", ratio: 0.12, align: "center" },
    { header: "DESCRIPTION", ratio: 0.38, align: "left" },
    { header: "WN NO", ratio: 0.15, align: "center" },
    { header: "QTY", ratio: 0.08, align: "center" },
    { header: "COMPLAINT", ratio: 0.22, align: "left" },
  ];

  const columnStyles = {};
  columns.forEach((col, index) => {
    columnStyles[index] = {
      cellWidth: contentWidth * col.ratio,
      halign: col.align,
    };
  });

  const tableHead = [columns.map((col) => col.header)];
  const tableBody = data.map((item, index) => {
    const qty = Number(item.tr_qty || item.qty || 0);
    return [
      (index + 1).toString(),
      item.code || "",
      item.idesc || item.description || "",
      item.wnno || item.WNNO || "",
      qty.toFixed(2),
      item.complaint1 || item.c1 || "",
    ];
  });

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: yPosition,
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 3,
      overflow: "linebreak",
      textColor: [71, 85, 105], // Slate 600 text
      lineColor: [226, 232, 240], // Slate 200 border
      lineWidth: 0.1,
    },
    headStyles: {
      fontStyle: "bold",
      halign: "center",
      fillColor: [30, 41, 59], // Slate 800 modern dark header (Replacing old blue)
      textColor: [255, 255, 255], // White text
      lineColor: [30, 41, 59], // Slate 800 border
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252], // Slate 50 alt row
    },
    columnStyles,
    margin: { left: margin, right: margin, bottom: 40 },
    tableWidth: contentWidth,
  });

  let currentY = doc.lastAutoTable.finalY + 15;

  if (currentY > pageHeight - 40) {
    doc.addPage();
    currentY = 20;
  }

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.setTextColor(100, 116, 139);
  doc.text("PREPARED BY", margin, currentY);
  doc.text("AUTHORIZED SIGNATORY", pageWidth - margin, currentY, {
    align: "right",
  });

  if (REPORT_FOOTER_IMAGE) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      drawFooter(doc, pageWidth, pageHeight, REPORT_FOOTER_IMAGE);
    }
  }
};

const generatePDF = (
  doc,
  pageWidth,
  pageHeight,
  templateId,
  data,
  COMPANY_NAME,
  docType = "delivery_order", //  "sales_order", "delivery_order", "quotation"
  REPORT_HEADER_IMAGE = null,
  REPORT_FOOTER_IMAGE = null,
  otherCosts = [],
  VATPERCENTAGE,
  VATMODE,
  REPORT_SEAL_IMAGE = null,
  REPORT_SIGNATURE = null,
  statusStamp = null,
  qrCodeImage = null,
) => {
  if (!data || data.length === 0) return;

  const config = getDocumentConfig(docType);

  if (docType === "purchase_invoice") {
    generatePurchaseInvoicePDF(
      doc,
      pageWidth,
      pageHeight,
      templateId,
      data,
      COMPANY_NAME,
      otherCosts,
      REPORT_HEADER_IMAGE,
      REPORT_FOOTER_IMAGE,
      VATPERCENTAGE,
    );
    return;
  }
  // In the generatePDF function, add this case:
  if (docType === "purchase_order") {
    switch (templateId) {
      case "po_template1":
        PurchaseOrderTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          statusStamp,
        );
        return;
      default:
        PurchaseOrderTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          statusStamp,
        );
        return;
    }
  }
  if (docType === "purchase_enquiry") {
    switch (templateId) {
      case "enq_template1":
        PurchaseEnquiryTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          statusStamp,
        );
        return;
      default:
        PurchaseEnquiryTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          statusStamp,
        );
        return;
    }
  }
  if (docType === "sample_issue") {
    switch (templateId) {
      case "sample_issue_template1":
        SampleIssueTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
      default:
        SampleIssueTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
    }
  }
  if (docType === "sample_return") {
    switch (templateId) {
      case "sample_return_template1":
        SampleReturnTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
      default:
        SampleReturnTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
    }
  }
  if (docType === "warranty_claim") {
    switch (templateId) {
      case "warranty_claim_template1":
        WarrantyClaimTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
        );
        return;
      default:
        WarrantyClaimTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
        );
        return;
    }
  }
  if (docType === "goods_in_transit") {
    switch (templateId) {
      case "goods_in_transit_template1":
        GoodsInTransitTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
        );
        return;
      default:
        GoodsInTransitTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
        );
        return;
    }
  }
  if (docType === "branch_transfer_out") {
    switch (templateId) {
      case "branch_transfer_out_template1":
        BranchTransferOutTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
      default:
        BranchTransferOutTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
    }
  }
  if (docType === "work_order") {
    switch (templateId) {
      case "work_order_template1":
        WorkOrderTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
      default:
        WorkOrderTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
        );
        return;
    }
  }
  if (docType === "sales_return" && templateId === "sret_template_saudi") {
    SaudiSalesReturnTemplate(
      doc,
      pageWidth,
      pageHeight,
      data,
      COMPANY_NAME,
      config,
      REPORT_HEADER_IMAGE,
      REPORT_FOOTER_IMAGE,
      true,
      VATPERCENTAGE,
      VATMODE,
      qrCodeImage,
    );
    return;
  }
  if (docType === "sales_return" && templateId === "sret_template1") {
    SalesReturnTemplate(
      doc,
      pageWidth,
      pageHeight,
      data,
      COMPANY_NAME,
      config,
      REPORT_HEADER_IMAGE,
      REPORT_FOOTER_IMAGE,
      false,
      VATPERCENTAGE,
      VATMODE,
    );
    return;
  }
  if (docType === "purchase_return") {
    PurchaseReturnTemplate(
      doc,
      pageWidth,
      pageHeight,
      data,
      COMPANY_NAME,
      config,
      REPORT_HEADER_IMAGE,
      REPORT_FOOTER_IMAGE,
      true,
      VATPERCENTAGE,
      VATMODE,
    );
    return;
  }
  if (docType === "location_transfer") {
    LocationTransferTemplate(
      doc,
      pageWidth,
      pageHeight,
      data,
      COMPANY_NAME,
      REPORT_HEADER_IMAGE,
      REPORT_FOOTER_IMAGE,
      VATPERCENTAGE,
      VATMODE,
      REPORT_SEAL_IMAGE,
    );
    return;
  }

  if (docType === "quotation") {
    switch (templateId) {
      case "quotation_template1":
        QuotationTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          true,
        );
        return;
      case "quotation_template2":
        QuotationTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          false,
        );
        return;
      default:
        QuotationTemplate(
          doc,
          pageWidth,
          pageHeight,
          data,
          COMPANY_NAME,
          REPORT_HEADER_IMAGE,
          REPORT_FOOTER_IMAGE,
          VATPERCENTAGE,
          VATMODE,
          REPORT_SEAL_IMAGE,
          REPORT_SIGNATURE,
          false,
        );
        return;
    }
  }

  const prefixMap = {
    sales_order: "so",
    delivery_order: "do",
    purchase_order: "po",
    quotation: "qt",
    sales_return: "srt",
  };

  const prefix = prefixMap[docType] || "do";

  const resolvedTemplateId =
    templateId && templateId.includes("_template")
      ? templateId
      : `${prefix}_template1`;

  switch (resolvedTemplateId) {
    case `${prefix}_template1`: // Without Header, No Code
      GenericWithoutHeaderLayoutPrint(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        false,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
      break;

    case `${prefix}_template2`: // With Header, No Code
      GenericWithHeaderLayoutPrint(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        false,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
      break;

    case `${prefix}_template3`: // Without Header, With Code
      GenericWithoutHeaderLayoutPrint(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        true,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
      break;

    case `${prefix}_template4`: // With Header, With Code
      GenericWithHeaderLayoutPrint(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        true,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
      break;
    case `${prefix}_template5`: // Without Header, No Code, No Balance Due
      GenericWithoutHeaderLayoutPrintNoBalance(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        false,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
      break;

    default:
      GenericWithoutHeaderLayoutPrint(
        doc,
        pageWidth,
        pageHeight,
        data,
        COMPANY_NAME,
        config,
        false,
        REPORT_HEADER_IMAGE,
        REPORT_FOOTER_IMAGE,
        VATPERCENTAGE,
        VATMODE,
        REPORT_SEAL_IMAGE,
        REPORT_SIGNATURE,
      );
  }
};

export default generatePDF;
export {
  SampleIssueTemplate,
  SampleReturnTemplate,
  getDocumentConfig,
  GenericWithoutHeaderLayoutPrint,
  GenericWithHeaderLayoutPrint,
  SalesReturnTemplate,
  SaudiSalesReturnTemplate,
  PurchaseReturnTemplate,
  GoodsInTransitTemplate,
  LocationTransferTemplate,
};
